const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanUpgrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor_00000013876646643919197920000017874447876317227658_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M89.166,257.047 C0.343,308.33,0.345,391.475,89.171,442.757c88.826,51.282,232.839,51.282,321.663,0s88.821-134.428-0.005-185.71 C322.003,205.765,177.99,205.765,89.166,257.047z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_00000070101267998793187380000000496834666359127990_",
    style: {
      fill: "#E0E0E0"
    },
    cx: 217.357,
    cy: 439.423,
    rx: 42.909,
    ry: 24.774
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_00000113335031550996092770000010721100194336771736_",
    style: {
      fill: "#E0E0E0"
    },
    cx: 289.24,
    cy: 419.812,
    rx: 46.024,
    ry: 26.572
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants_00000101066594264321812220000001324739403299257779_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M74.404,408.32l-9.32,5.38c0.08-5.09-0.26-14.73-2.96-27.26c-6.18-28.72-18.72-33.71-24.83-44.89 c-6.42-11.76,1.83-18.81,9.61-17.6c6.95,1.07,17.96,9.62,23.47,27.27C77.644,374.49,75.854,397.71,74.404,408.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M74.404,408.32l-9.32,5.38c0.08-5.09-0.26-14.73-2.96-27.26 c-6.18-28.72-18.72-33.71-24.83-44.89c-6.42-11.76,1.83-18.81,9.61-17.6c6.95,1.07,17.96,9.62,23.47,27.27 C77.644,374.49,75.854,397.71,74.404,408.32z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_406_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.923,406.045c-0.268-0.038-0.453-0.285-0.415-0.553c4.942-34.571-10.474-64.357-22.999-74.466 c-0.21-0.171-0.243-0.478-0.074-0.689c0.172-0.212,0.478-0.243,0.689-0.074c12.704,10.255,28.348,40.417,23.352,75.368 C69.438,405.898,69.191,406.084,68.923,406.045z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_342_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M69.734,411.02l-4.65,2.68l-0.76,0.44c-1.53-6.95-5.62-14.2-13.37-21.97 c-9.09-9.11-21.76-17.62-19.52-25.27c2.23-7.65,12.46-5.63,19.52-1.1C57.583,370.06,71.704,385.77,69.734,411.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M69.734,411.02l-4.65,2.68l-0.76,0.44c-1.53-6.95-5.62-14.2-13.37-21.97 c-9.09-9.11-21.76-17.62-19.52-25.27c2.23-7.65,12.46-5.63,19.52-1.1C57.583,370.06,71.704,385.77,69.734,411.02z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_429_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M67.255,408.867c-0.229-0.033-0.41-0.225-0.419-0.465c-0.649-16.942-19.24-38.871-28.093-42.469 c-0.251-0.101-0.371-0.387-0.269-0.637c0.1-0.251,0.383-0.374,0.637-0.269c9.283,3.772,28.029,25.729,28.703,43.337 c0.011,0.271-0.2,0.498-0.47,0.508C67.314,408.874,67.285,408.872,67.255,408.867z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_00000076566463977385047610000012271667997913997731_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "104.258,460.122 184.95,337.594 130.521,306.169 49.829,428.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "104.258,460.122 184.95,337.594 130.521,306.169 49.829,428.698  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "184.949,337.594 104.258,460.122 136.915,441.267 195.764,352.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "184.949,337.594 104.258,460.122 136.915,441.267 195.764,352.258  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "331.38,71.906 336.713,95.773 358.632,108.598 353.177,84.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "331.38,71.906 336.713,95.773 358.632,108.598 353.177,84.49  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "284.128,189.61 353.177,84.49 331.38,71.906 414.256,48.525 429.352,128.47  407.606,115.915 338.556,221.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "284.128,189.61 353.177,84.49 331.38,71.906 414.256,48.525 429.352,128.47  407.606,115.915 338.556,221.035  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "407.606,115.915 338.592,221.034 350.815,234.926 413.145,140.063 434.834,152.592  429.352,128.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "407.606,115.915 338.592,221.034 350.815,234.926 413.145,140.063 434.834,152.592  429.352,128.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "296.351,203.604 284.128,189.712 338.592,221.034 350.815,234.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "296.351,203.604 284.128,189.712 338.592,221.034 350.815,234.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "413.145,140.063 407.606,115.915 429.352,128.47 434.834,152.592  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Hand_00000108308197908197656490000003399886740613852314_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4575_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4186_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M328.922,395.622c0,5.777-0.046,13.594-0.016,18.57 c0.008,1.083,0.015,2.416,0.015,4.188c0.008,0.008,0.008,0.015,0,0.023c-0.795,5.203-4.642,10.284-11.541,14.268 c-15.6,9.004-40.894,9.004-56.495,0c-8.043-4.642-11.935-10.776-11.678-16.858v-0.045c0.046-0.515,0.099-1.053,0.167-1.613 c0-0.023,0.007-0.045,0.007-0.061c0.674-5.915,1.16-11.832,1.493-17.383c0.53-8.807,0.456-12.685,0.384-17.426 c-0.089-5.85-2.52-10.448-8.692-15.635c-6.172-5.195-18.44-22.931-18.44-22.931l81.372-41.826l23.136,73.277 C328.634,372.168,328.922,389.844,328.922,395.622z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4503_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4578_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4496_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M306.124,283.73c0,0-1.536,6.164-8.807-1.99c-7.271-8.154-19.167-20.618-31.702-32.609 c-6.009-5.748-30.085-25.116-46.239-39.751c-5.146-5.309-12.459-9.027-17.485-5.164c-5.026,3.863-5.041,13.353-1.875,18.057 c2.802,4.164,8.806,9.945,13.39,14.097c-0.029,0.251-0.057,0.498-0.087,0.751c-0.867,7.566-2.416,16.076-3.151,25.252 c-0.438,5.463-7.026,12.351-6.937,17.962c1.938,7.969,12.526,16.575,20.014,22.554c7.488,5.979,10.748,8.413,10.664,10.3 c-0.13,2.894-12.256-7.629-17.651-11.333c0.3,17.173-10.673,19.24-10.673,19.24c1.648,3.306,11.006,10.587,24.307,27.616 c5.251,6.722,58.691-37.515,58.691-37.515l12.69-8.146l8.93-14.775L306.124,283.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M301.685,298.884c-5.013,6.293-24.703,26.4-9.209,53.049c-1.666-1.583-2.544-2.794-2.9-3.272 c-2.227-2.938-3.968-6.248-5.21-9.716c-0.046-0.129-0.083-0.25-0.129-0.371c-3.521-10.148-2.317-20.47,4.248-29.194 c5.172-6.854,14.586-13.51,15.843-20.902c0.046-0.273,0.076-0.538,0.091-0.803 C304.638,289.978,304.896,294.863,301.685,298.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#F28F8F"
    },
    d: "M199.03,208.01c-1.974,4.519-1.389,10.736,0.985,14.264 c2.802,4.164,8.806,9.945,13.39,14.097c-0.023,0.2-0.046,0.399-0.069,0.599c2.021,1.734,4.194,3.573,6.578,5.671 c5.739,5.051,13.329,11.566,19.058,16.626c2.868,2.533,16.502,13.5,21.446,17.913c-7.613-8.347-24.706-23.5-33.308-31.969 c-6.495-6.394-16.066-15.313-19.185-18.865c-3.119-3.552-4.939-5.985-6.035-7.326 C198.066,214.334,198.908,208.924,199.03,208.01z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M213.617,328.5c2.695-0.245,6.155-2.241,7.553-4.557c2.012-3.334,2.393-5.924,1.85-11.123 c-0.139-1.33-0.469-3.729-1.469-7.166c-1.784-1.283-3.64-2.662-5.294-3.797c0.3,17.173-10.673,19.24-10.673,19.24 c0.747,1.497,3.079,3.815,6.638,7.479C212.689,328.566,213.155,328.542,213.617,328.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4583_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4585_",
    style: {
      fill: "#F28F8F"
    },
    d: "M204.828,259.118c-0.43,0.395,5.649,6.25,6.288,6.607 c2.251,1.254,6.555-0.308,8.416-1.864c1.175-0.982,2.033-2.305,2.627-3.716c2.025-4.808,1.036-10.29,0.009-15.405 c-0.161-0.801-0.39-1.7-1.103-2.099c-0.119,2.675-2.48,3.843-4.228,5.448c-1.668,1.532-3.335,3.064-5.003,4.595 C209.498,254.828,207.163,256.973,204.828,259.118z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F28F8F"
    },
    points: "218.649,262.267 250.472,294.387 213.319,263.245  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M214.301,289.709c3.081-0.995,5.651-3.478,6.721-6.534c0.912-2.605,0.755-5.447,0.579-8.201 c-0.15-2.342-0.315-4.729-1.18-6.911l-14.886,5.053c-1.291,2.496-2.342,4.962-2.306,7.22c0.79,3.249,2.855,6.542,5.768,9.708 C210.697,290.331,212.66,290.239,214.301,289.709z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4488_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4584_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M210.34,236.129c6.542-0.597,9.974,2.274,11.437,8.138 c0.554,2.219,0.612,5.735,0,10.096c-0.612,4.361-4.742,9.585-10.059,8.803c-0.085-0.013-0.171-0.026-0.257-0.04 c-8.596-1.397-9.57-6.015-9.57-13.468C201.891,242.205,204.52,236.66,210.34,236.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4500_",
    style: {
      opacity: 0.5,
      fill: "#F28F8F"
    },
    d: "M218.063,237.858c0.474,0.41,3.248,3.127,3.273,10.648 c0.027,8.222-4.098,9.927-8.651,10.659c-4.553,0.732-10.694-2.102-10.694-6.22l-0.003,0.001 c0.394,5.531,2.221,9.002,9.473,10.18c0.087,0.014,0.173,0.027,0.258,0.04c5.317,0.782,9.447-4.443,10.059-8.803 c0.612-4.361,0.554-7.878,0-10.096C221.059,241.39,219.863,239.238,218.063,237.858z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4494_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4580_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M210.488,262.337c5.975-0.545,9.111,2.077,10.448,7.434 c0.505,2.027,0.559,5.239,0,9.223c-0.559,3.983-4.332,8.756-9.189,8.041c-0.078-0.012-0.156-0.024-0.235-0.036 c-7.852-1.276-8.742-5.494-8.742-12.303C202.77,267.887,205.172,262.822,210.488,262.337z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4502_",
    style: {
      opacity: 0.5,
      fill: "#F28F8F"
    },
    d: "M218.816,265.172c0.842,1.249,1.453,4.324,0.958,8.981 c-0.649,6.102-1.955,9.068-7.295,9.452c-5.532,0.398-8.931-2.163-9.515-4.858c0.526,4.439,2.398,7.251,8.548,8.251 c0.079,0.013,0.158,0.025,0.235,0.036c4.857,0.715,8.63-4.058,9.189-8.041c0.559-3.983,0.506-7.196,0-9.222 C220.467,267.893,219.771,266.359,218.816,265.172z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4501_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4587_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M210.809,299.304c6.201-0.566,10.842,2.381,10.842,7.715v9.571 c0,5.095-4.495,9.087-9.536,8.345c-0.081-0.012-0.162-0.024-0.244-0.038c-8.149-1.324-8.051-8.768-8.149-12.677 C203.624,308.312,205.292,299.807,210.809,299.304z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4572_",
    style: {
      opacity: 0.5,
      fill: "#F28F8F"
    },
    d: "M218.631,301.008c2.709,2.836,1.654,8.606,1.445,14.297 c-0.145,3.948-2.2,7.22-7.597,7.22s-7.814-3.298-8.547-6.526l-0.003-0.007c0.447,3.728,2.005,7.94,7.942,8.905 c0.082,0.013,0.164,0.026,0.244,0.038c5.041,0.741,9.536-3.25,9.536-8.345v-9.571 C221.651,304.388,220.518,302.342,218.631,301.008z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "142.069,297.42 275.461,196.285 329.925,227.709 196.498,328.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "329.925,227.709 342.148,241.6 207.313,343.509 196.498,328.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "329.925,227.709 342.148,241.6 207.313,343.509 196.498,328.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AB55"
    },
    points: "142.069,297.423 152.884,312.087 207.313,343.509 196.498,328.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "142.069,297.423 152.884,312.087 207.313,343.509 196.498,328.845  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4573_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5075_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M328.632,372.169c0-14.182,1.034-33.212,3.38-49.618 c2.346-16.406,1.893-30.449,1.175-34.416c-0.718-3.967-0.921-9.733-7.044-17.051c-2.885-3.449-9.213-8.478-14.49-14.675 c-5.324-6.253-10.293-13.196-13.109-16.993c-2.817-3.797-9.811,2.316-9.471,14.422c0.278,9.889,7.036,18.542,9.648,22.24 c3.185,4.512,5.448,8.87,5.702,11.591c0.215,2.303,0.475,7.182-2.738,11.216c-5.011,6.292-24.704,26.399-9.206,53.049v24.45 L328.632,372.169z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5078_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M299.809,246.818c0,0,6.01,8.153,7.93,9.201 c1.919,1.048,2.466-1.342,2.466-1.342l-0.007-0.011c-2.76-3.878-7.909-10.932-11.655-15.25 C299.025,240.229,300.124,243.212,299.809,246.818z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4526_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.809,246.818c0,0,6.009,8.156,7.93,9.201 c1.796,0.977,2.466-1.342,2.466-1.342l-0.007-0.011c-2.76-3.878-7.909-10.932-11.655-15.25 C299.025,240.229,300.124,243.212,299.809,246.818z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5144_",
    style: {
      fill: "#F28F8F"
    },
    d: "M310.205,254.677l-0.007-0.011c0.007,0.011-0.578-0.915-0.893-1.249 c0.274,1.911-1.112,2.796-1.112,2.796l0,0C309.774,256.676,310.205,254.677,310.205,254.677z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Coins_00000083049784496214317170000009279600788974970533_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coin_00000103980611594076281040000007134025056386098057_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000098193741233465738780000013208253727249361549_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000135691052817113445260000010643706408479429257_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062153751115291488060000009112604095745193381_",
    style: {
      fill: "#00AB55"
    },
    d: "M251.195,430.154 c-1.711-2.887-4.556-5.599-8.545-7.902c-13.969-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932 v7.309h0.025c0.257,5.081,3.734,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0 c6.717-3.878,10.22-8.915,10.477-13.997v0.001v-7.309H251.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000048492207602884127190000008810650329617001888_",
    style: {
      opacity: 0.25
    },
    d: "M251.195,430.154 c-1.711-2.887-4.556-5.599-8.545-7.902c-13.969-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932 v7.309h0.025c0.257,5.081,3.734,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0 c6.717-3.878,10.22-8.915,10.477-13.997v0.001v-7.309H251.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000076592974962876449350000004921394022638588556_",
    style: {
      opacity: 0.1
    },
    d: "M217.359,416.203 c-9.155,0-18.311,2.016-25.296,6.049c-3.989,2.303-6.834,5.015-8.544,7.902h-1.933v7.309h0.025 c0.258,5.081,3.735,10.118,10.452,13.996c6.985,4.033,16.141,6.049,25.296,6.049V416.203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165236813520921300420000008700596493100345508_",
    style: {
      opacity: 0.1
    },
    d: "M197.821,419.556 c-2.036,0.768-3.969,1.664-5.757,2.696c-3.989,2.303-6.834,5.015-8.544,7.902h-1.933v7.309h0.025 c0.258,5.081,3.735,10.118,10.452,13.996c1.788,1.032,3.722,1.928,5.757,2.696V419.556z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000075881099399439102900000015730558681411440568_",
    style: {
      opacity: 0.5,
      fill: "#00AB55"
    },
    d: "M236.893,419.556 c2.036,0.768,3.969,1.664,5.757,2.696c3.989,2.303,6.834,5.015,8.544,7.902h1.933v7.309v-0.001 c-0.258,5.081-3.76,10.118-10.477,13.997c-1.788,1.032-3.722,1.928-5.757,2.696V419.556z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065792373886931239900000014519379980595777460_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000132806614950989387490000017171574323181616810_",
    style: {
      fill: "#00AB55"
    },
    d: "M192.063,415.553 c-13.97,8.065-13.968,21.142,0,29.207c12.223,7.057,31.09,7.94,44.975,2.648l0.002-0.001 c0.185-0.071,0.369-0.142,0.554-0.216c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.803-24.819 c-0.002-0.003-0.004-0.004-0.004-0.004c-1.547-1.569-3.481-3.045-5.8-4.384C228.683,407.489,206.033,407.488,192.063,415.553 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023972121443260143970000015492221557111523495_",
    style: {
      opacity: 0.2
    },
    d: "M192.063,415.553 c-13.97,8.065-13.968,21.142,0,29.207c12.223,7.057,31.09,7.94,44.975,2.648l0.002-0.001 c0.185-0.071,0.369-0.142,0.554-0.216c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.803-24.819 c-0.002-0.003-0.004-0.004-0.004-0.004c-1.547-1.569-3.481-3.045-5.8-4.384C228.683,407.489,206.033,407.488,192.063,415.553 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000027598461227497604900000006996426904957704847_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M248.454,419.942 c0.15,0.169,5.036,5.324,3.741,12.742c-1.237,7.098-11.176,13.072-14.601,14.508c1.778-0.707,3.473-1.516,5.057-2.431 C254.3,438.034,256.236,427.825,248.454,419.942z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042728436356887422960000010687846705417800865_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M186.26,440.373 c-0.15-0.169-5.036-5.324-3.741-12.741c1.237-7.098,11.176-13.072,14.602-14.508c-1.778,0.707-3.473,1.516-5.057,2.431 C180.415,422.28,178.479,432.49,186.26,440.373z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164471524041712897720000011869238116602220717_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M240.882,443.704c12.986-7.497,12.986-19.653,0-27.15c-12.986-7.497-34.04-7.497-47.026,0 c-12.986,7.497-12.986,19.653,0,27.15C206.842,451.201,227.896,451.201,240.882,443.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M240.882,443.704c12.986-7.497,12.986-19.653,0-27.15 c-12.986-7.497-34.04-7.497-47.026,0c-12.986,7.497-12.986,19.653,0,27.15C206.842,451.201,227.896,451.201,240.882,443.704z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000071541504601609598130000001206223098516179584_",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M249.111,435.862 c2.673-4.94,1.801-10.386-2.611-15.005c-0.816-0.854-1.757-1.679-2.817-2.467c-0.822-0.616-1.723-1.208-2.692-1.774 c-0.531-0.311-1.076-0.607-1.638-0.888c1.382,2.274,0.876,4.711-6.956,5.168c-15.326,0.895,4.096,15.541,4.096,15.541 S246.372,431.667,249.111,435.862z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000151523000271589786590000007131072593966003121_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M247.53,431.811 c2.3-0.258,3.44-2.623,2.546-5.283c-0.894-2.66-3.483-4.608-5.783-4.35c-2.3,0.258-3.44,2.623-2.546,5.283 S245.23,432.068,247.53,431.811z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000170253496081874527980000011080035471828115359_",
    style: {
      fill: "#00AB55"
    },
    d: "M223.289,444.017 c-0.755-5.691-25.633-21.447-25.633-21.447s-5.517-2.214-3.685-6.07c-0.957,0.549-1.844,1.123-2.66,1.72 c-0.575,0.415-1.113,0.841-1.616,1.28c-7.406,6.413-7.416,14.837,0.003,21.258c0.5,0.437,1.041,0.865,1.613,1.282 c0.763,0.556,1.582,1.09,2.467,1.605c0.844,0.495,1.726,0.953,2.636,1.381c0.725,0.343,1.479,0.666,2.242,0.966 c0.76,0.301,1.538,0.581,2.332,0.841c2.364,0.776,4.859,1.368,7.422,1.783c0.553,0.088,1.113,0.17,1.67,0.242 c2.445,0.314,4.93,0.471,7.422,0.466c3.058-0.006,6.115-0.254,9.079-0.745C226.579,448.577,222.577,447.76,223.289,444.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000169518002892707873580000000710276852642772896_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M223.289,444.017 c-0.755-5.691-25.633-21.447-25.633-21.447s-5.517-2.214-3.685-6.07c-0.957,0.549-1.844,1.123-2.66,1.72 c-0.575,0.415-1.113,0.841-1.616,1.28c-7.406,6.413-7.416,14.837,0.003,21.258c0.5,0.437,1.041,0.865,1.613,1.282 c0.763,0.556,1.582,1.09,2.467,1.605c0.844,0.495,1.726,0.953,2.636,1.381c0.725,0.343,1.479,0.666,2.242,0.966 c0.76,0.301,1.538,0.581,2.332,0.841c2.364,0.776,4.859,1.368,7.422,1.783c0.553,0.088,1.113,0.17,1.67,0.242 c2.445,0.314,4.93,0.471,7.422,0.466c3.058-0.006,6.115-0.254,9.079-0.745C226.579,448.577,222.577,447.76,223.289,444.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142142893654978381720000005364988252515423113_",
    style: {
      fill: "#00AB55"
    },
    d: "M199.841,420.014 c-9.28,5.358-9.656,13.906-1.132,19.525c0.362,0.238,0.742,0.474,1.136,0.702c9.675,5.586,25.355,5.586,35.03,0 c9.675-5.585,9.678-14.641,0.003-20.226c-0.394-0.228-0.803-0.447-1.216-0.656C223.93,414.437,209.121,414.657,199.841,420.014 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047043761176189183880000005208398859833575048_",
    style: {
      opacity: 0.2
    },
    d: "M199.841,420.014 c-9.28,5.358-9.656,13.906-1.132,19.525c0.362,0.238,0.742,0.474,1.136,0.702c9.675,5.586,25.355,5.586,35.03,0 c9.675-5.585,9.678-14.641,0.003-20.226c-0.394-0.228-0.803-0.447-1.216-0.656C223.93,414.437,209.121,414.657,199.841,420.014 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#00AB55"
    },
    cx: 217.371,
    cy: 430.128,
    rx: 23.679,
    ry: 13.671
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5
    },
    cx: 217.371,
    cy: 430.128,
    rx: 23.679,
    ry: 13.671
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M200.627,424.274c9.247-5.339,24.24-5.339,33.488,0c3.782,2.183,6.015,4.921,6.703,7.76 c-0.689,2.839-2.922,5.577-6.703,7.76c-9.247,5.339-24.24,5.339-33.487,0c-3.782-2.183-6.015-4.921-6.703-7.76 C194.613,429.195,196.846,426.457,200.627,424.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35
    },
    d: "M200.627,424.274c9.247-5.339,24.24-5.339,33.488,0c3.782,2.183,6.015,4.921,6.703,7.76 c-0.689,2.839-2.922,5.577-6.703,7.76c-9.247,5.339-24.24,5.339-33.487,0c-3.782-2.183-6.015-4.921-6.703-7.76 C194.613,429.195,196.846,426.457,200.627,424.274z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M232.281,434.246c-0.002-0.461,0.006-2.342,0.002-2.826c-0.009-1.159-0.803-2.283-2.528-3.293 c-0.019-0.014-0.041-0.027-0.06-0.038c-3.18-1.836-6.465-1.596-9.392-0.859c-0.009,0.002-0.016,0.002-0.025,0.004 c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164c-0.003,0.002-0.003,0.002-0.006,0.004 c-0.654,0.139-1.241,0.204-1.788,0.17c-0.523-0.031-1.009-0.161-1.481-0.393c0.04-0.027,0.076-0.055,0.118-0.082 c0.116-0.078,0.241-0.154,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063v-2.81 c-2.698-0.915-5.502-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913l-3.036-1.753l-3.624,2.092v2.81l1.241,0.716 c-0.355,0.551-0.535,1.1-0.533,1.639c0.002,0.467,0.005,2.334,0.004,2.805c-0.003,1.161,0.832,2.28,2.58,3.289 c1.688,0.975,3.367,1.381,5.002,1.441l0.003-0.002c0.331,0.015,0.669,0.011,1-0.004c1.895-0.09,3.711-0.597,5.374-1.161 c0.356-0.119,0.703-0.24,1.046-0.36l-3.056,3.064v2.81c4.314,1.729,8.526,0.908,11.709-0.507l2.998,1.731l3.623-2.092v-2.81 l-1.244-0.718C232.074,435.462,232.284,434.849,232.281,434.246z M224.641,434.004c-0.278,0.16-0.56,0.301-0.841,0.421 c-2.154,0.922-4.374,0.725-5.924,0.088c2.837-1,5.206-1.876,7.225-0.801C224.959,433.81,224.808,433.908,224.641,434.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163037492733251557660000000263119536872273294_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103987159501351174100000017606195016983707793_",
    style: {
      fill: "#00AB55"
    },
    d: "M220.304,427.23 c-0.009,0.002-0.016,0.002-0.025,0.004c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164 c-0.003,0.002-0.003,0.002-0.006,0.004c-0.654,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514 c-1.166-0.673-1.335-1.659,0.36-2.771c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493 c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913 l-3.036-1.753l-3.624,2.092l3.001,1.733c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.014,0.669,0.011,1-0.004c1.895-0.09,3.711-0.598,5.374-1.161 c3.477-1.163,6.294-2.533,8.635-1.181c1.57,0.906,1.135,2.045-0.588,3.04c-0.278,0.16-0.56,0.301-0.841,0.421 c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191c4.314,1.729,8.526,0.908,11.709-0.507l2.998,1.731l3.624-2.092 l-2.998-1.731c3.014-2.332,3.361-4.872-0.159-6.933c-0.019-0.014-0.041-0.027-0.059-0.038 C226.517,426.253,223.231,426.493,220.304,427.23z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078015170183054493730000009806017073484197822_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000149346392159309809460000002889264348203871623_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.304,427.23 c-0.009,0.002-0.016,0.002-0.025,0.004c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164 c-0.003,0.002-0.003,0.002-0.006,0.004c-0.654,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514 c-1.166-0.673-1.335-1.659,0.36-2.771c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493 c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913 l-3.036-1.753l-3.624,2.092l3.001,1.733c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.014,0.669,0.011,1-0.004c1.895-0.09,3.711-0.598,5.374-1.161 c3.477-1.163,6.294-2.533,8.635-1.181c1.57,0.906,1.135,2.045-0.588,3.04c-0.278,0.16-0.56,0.301-0.841,0.421 c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191c4.314,1.729,8.526,0.908,11.709-0.507l2.998,1.731l3.624-2.092 l-2.998-1.731c3.014-2.332,3.361-4.872-0.159-6.933c-0.019-0.014-0.041-0.027-0.059-0.038 C226.517,426.253,223.231,426.493,220.304,427.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000018208885617566159570000012934037870796565651_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: " 201.923,423.421 205.58,421.763 208.581,423.082 205.545,421.33  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000057116705687482108130000008337070713544992904_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M210.799,422.284c1.954-0.423,5.115-0.543,7.788,0.263l-2.103,2.986l3.036-3.062 C216.288,421.44,213.426,421.51,210.799,422.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093145736112218101680000012460138664762458514_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M229.696,428.089c0.019,0.011,0.041,0.023,0.059,0.038c3.52,2.061,3.173,4.601,0.159,6.933c2.67-2.91,2.189-4.939-0.713-6.614 c-2.895-1.672-6.603-1.654-8.898-1.217C223.231,426.493,226.517,426.253,229.696,428.089z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000177482504518061130460000005849675274544127629_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: " 229.915,435.06 232.214,436.826 229.29,438.883 232.913,436.791  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168077687060320367420000002110061124444760212_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M223.8,434.424 c-3.183,1.509-5.774,0.504-5.774,0.504l-3.442,2.731l3.183-3.191C219.32,435.141,221.596,435.369,223.8,434.424z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000085949461970402180930000013472613368081249462_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M213.007,429.49 c-1.37,0.538-3.342,0.447-4.34-0.411c-1.047-0.901-0.375-1.866,1.188-2.704c-1.695,1.112-1.526,2.098-0.36,2.771 c0.547,0.316,1.11,0.478,1.723,0.514C211.766,429.694,212.354,429.629,213.007,429.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000065787771885037770130000012436828871805221265_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M204.894,425.177c-0.256,0.227-2.437,2.26-1.475,4.293c1.022,2.168,4.22,3.559,6.799,3.839l-0.003,0.002 c-1.635-0.059-3.314-0.466-5.002-1.44C201.786,429.892,201.849,427.491,204.894,425.177z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coin_00000149383375364639736200000005687636815385633175_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111906556823549774270000001681892117087400353_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000102507921013546043360000010898014835018269874_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060732066356979980090000015685723096975385525_",
    style: {
      fill: "#00AB55"
    },
    d: "M257.962,419.859 c-1.711-2.887-4.556-5.599-8.545-7.902c-13.969-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932 v7.309h0.025c0.257,5.081,3.735,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0 c6.717-3.878,10.22-8.915,10.477-13.997v0.001v-7.309H257.962z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150069076333276728040000013425194565922729876_",
    style: {
      opacity: 0.25
    },
    d: "M257.962,419.859 c-1.711-2.887-4.556-5.599-8.545-7.902c-13.969-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932 v7.309h0.025c0.257,5.081,3.735,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0 c6.717-3.878,10.22-8.915,10.477-13.997v0.001v-7.309H257.962z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093149182669680956720000000458645422232377746_",
    style: {
      opacity: 0.1
    },
    d: "M224.126,405.909 c-9.155,0-18.311,2.016-25.296,6.049c-3.989,2.303-6.834,5.015-8.544,7.902h-1.933v7.309h0.025 c0.258,5.081,3.735,10.118,10.452,13.996c6.985,4.033,16.141,6.049,25.296,6.049V405.909z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000172420775487325088390000007535898364619309969_",
    style: {
      opacity: 0.1
    },
    d: "M204.587,409.261 c-2.036,0.768-3.969,1.664-5.757,2.696c-3.989,2.303-6.834,5.015-8.544,7.902h-1.933v7.309h0.025 c0.258,5.081,3.735,10.118,10.452,13.996c1.788,1.032,3.721,1.928,5.757,2.696V409.261z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000125595844922013568370000006131491861743865488_",
    style: {
      opacity: 0.5,
      fill: "#00AB55"
    },
    d: "M243.66,409.261 c2.036,0.768,3.969,1.664,5.757,2.696c3.989,2.303,6.834,5.015,8.544,7.902h1.933v7.309v-0.001 c-0.258,5.081-3.76,10.119-10.477,13.997c-1.788,1.032-3.721,1.928-5.757,2.696V409.261z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000141450728454403191090000010649722510432578455_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000139975278816358507610000007967783246791797909_",
    style: {
      fill: "#00AB55"
    },
    d: "M198.829,405.259 c-13.97,8.066-13.968,21.142,0,29.207c12.223,7.057,31.09,7.94,44.975,2.647l0.002-0.001 c0.185-0.071,0.369-0.142,0.554-0.216c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.803-24.819 c-0.002-0.003-0.004-0.004-0.004-0.004c-1.547-1.569-3.481-3.045-5.799-4.384 C235.449,397.195,212.799,397.194,198.829,405.259z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000096049566672255515950000013259231464142876598_",
    style: {
      opacity: 0.2
    },
    d: "M198.829,405.259 c-13.97,8.066-13.968,21.142,0,29.207c12.223,7.057,31.09,7.94,44.975,2.647l0.002-0.001 c0.185-0.071,0.369-0.142,0.554-0.216c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.803-24.819 c-0.002-0.003-0.004-0.004-0.004-0.004c-1.547-1.569-3.481-3.045-5.799-4.384 C235.449,397.195,212.799,397.194,198.829,405.259z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000166640882703091115860000006345780597206560649_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M255.221,409.647 c0.15,0.169,5.036,5.324,3.741,12.742c-1.237,7.098-11.176,13.072-14.601,14.508c1.778-0.707,3.473-1.516,5.057-2.431 C261.067,427.74,263.003,417.531,255.221,409.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070798277357088628880000002983999578214175391_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M193.027,430.078 c-0.15-0.169-5.036-5.324-3.741-12.741c1.237-7.098,11.176-13.072,14.602-14.508c-1.778,0.707-3.473,1.516-5.057,2.431 C187.181,411.986,185.246,422.195,193.027,430.078z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000171709334758437979120000013464288578896904580_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M247.649,433.41c12.986-7.497,12.986-19.653,0-27.15c-12.986-7.497-34.04-7.497-47.026,0 c-12.986,7.497-12.986,19.653,0,27.15C213.609,440.907,234.663,440.907,247.649,433.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M247.649,433.41c12.986-7.497,12.986-19.653,0-27.15 c-12.986-7.497-34.04-7.497-47.026,0c-12.986,7.497-12.986,19.653,0,27.15C213.609,440.907,234.663,440.907,247.649,433.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155854625492989094570000006349871592901062034_",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M255.878,425.568 c2.673-4.94,1.801-10.386-2.611-15.005c-0.816-0.854-1.757-1.679-2.817-2.467c-0.822-0.616-1.723-1.208-2.692-1.774 c-0.531-0.31-1.076-0.606-1.638-0.888c1.382,2.274,0.875,4.711-6.956,5.168c-15.326,0.895,4.096,15.541,4.096,15.541 S253.139,421.373,255.878,425.568z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000002365009207369903940000004316140383657997748_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M254.297,421.517 c2.3-0.258,3.44-2.623,2.546-5.283c-0.894-2.66-3.483-4.608-5.783-4.35c-2.3,0.258-3.44,2.623-2.546,5.283 C249.408,419.827,251.997,421.774,254.297,421.517z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000154425033125477405540000007770001179240472240_",
    style: {
      fill: "#00AB55"
    },
    d: "M230.055,433.723 c-0.755-5.691-25.633-21.447-25.633-21.447s-5.517-2.214-3.685-6.07c-0.957,0.549-1.844,1.123-2.661,1.72 c-0.575,0.415-1.113,0.841-1.616,1.28c-7.406,6.413-7.416,14.837,0.003,21.258c0.5,0.437,1.041,0.865,1.613,1.282 c0.763,0.556,1.582,1.09,2.467,1.605c0.844,0.495,1.726,0.953,2.636,1.381c0.725,0.343,1.479,0.666,2.242,0.966 c0.76,0.301,1.538,0.581,2.332,0.841c2.364,0.776,4.858,1.368,7.422,1.783c0.553,0.089,1.113,0.17,1.669,0.242 c2.445,0.314,4.93,0.471,7.422,0.466c3.059-0.006,6.115-0.254,9.079-0.745C233.346,438.283,229.344,437.466,230.055,433.723z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000075141327430028709690000008068275248579191228_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M230.055,433.723 c-0.755-5.691-25.633-21.447-25.633-21.447s-5.517-2.214-3.685-6.07c-0.957,0.549-1.844,1.123-2.661,1.72 c-0.575,0.415-1.113,0.841-1.616,1.28c-7.406,6.413-7.416,14.837,0.003,21.258c0.5,0.437,1.041,0.865,1.613,1.282 c0.763,0.556,1.582,1.09,2.467,1.605c0.844,0.495,1.726,0.953,2.636,1.381c0.725,0.343,1.479,0.666,2.242,0.966 c0.76,0.301,1.538,0.581,2.332,0.841c2.364,0.776,4.858,1.368,7.422,1.783c0.553,0.089,1.113,0.17,1.669,0.242 c2.445,0.314,4.93,0.471,7.422,0.466c3.059-0.006,6.115-0.254,9.079-0.745C233.346,438.283,229.344,437.466,230.055,433.723z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165217275131803462910000014264760972278047145_",
    style: {
      fill: "#00AB55"
    },
    d: "M206.607,409.72 c-9.28,5.358-9.656,13.906-1.132,19.525c0.362,0.238,0.742,0.474,1.136,0.702c9.675,5.586,25.355,5.586,35.03,0 c9.675-5.586,9.678-14.641,0.003-20.226c-0.394-0.228-0.803-0.447-1.216-0.656C230.696,404.143,215.888,404.362,206.607,409.72 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173845026287724846250000005432354189069086104_",
    style: {
      opacity: 0.2
    },
    d: "M206.607,409.72 c-9.28,5.358-9.656,13.906-1.132,19.525c0.362,0.238,0.742,0.474,1.136,0.702c9.675,5.586,25.355,5.586,35.03,0 c9.675-5.586,9.678-14.641,0.003-20.226c-0.394-0.228-0.803-0.447-1.216-0.656C230.696,404.143,215.888,404.362,206.607,409.72 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M207.394,410.166c-9.247,5.339-9.247,13.995,0,19.334c9.247,5.339,24.24,5.339,33.488,0 c9.247-5.339,9.247-13.995,0-19.334C231.634,404.828,216.641,404.828,207.394,410.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M207.394,410.166c-9.247,5.339-9.247,13.995,0,19.334c9.247,5.339,24.24,5.339,33.488,0 c9.247-5.339,9.247-13.995,0-19.334C231.634,404.828,216.641,404.828,207.394,410.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M207.394,413.98c9.247-5.339,24.24-5.339,33.488,0c3.781,2.183,6.014,4.921,6.703,7.76 c-0.689,2.839-2.922,5.577-6.703,7.76c-9.247,5.339-24.24,5.339-33.488,0c-3.782-2.183-6.015-4.922-6.703-7.76 C201.38,418.901,203.613,416.163,207.394,413.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35
    },
    d: "M207.394,413.98c9.247-5.339,24.24-5.339,33.488,0c3.781,2.183,6.014,4.921,6.703,7.76 c-0.689,2.839-2.922,5.577-6.703,7.76c-9.247,5.339-24.24,5.339-33.488,0c-3.782-2.183-6.015-4.922-6.703-7.76 C201.38,418.901,203.613,416.163,207.394,413.98z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M239.048,423.952c-0.002-0.461,0.006-2.342,0.002-2.826c-0.008-1.159-0.803-2.283-2.528-3.293 c-0.019-0.014-0.041-0.027-0.06-0.038c-3.18-1.836-6.465-1.596-9.392-0.859c-0.009,0.002-0.016,0.002-0.025,0.004 c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164c-0.003,0.002-0.003,0.002-0.006,0.004 c-0.653,0.139-1.241,0.204-1.788,0.17c-0.523-0.031-1.009-0.161-1.481-0.393c0.04-0.027,0.076-0.055,0.118-0.082 c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.355,0.991-0.493c1.845-0.78,3.62-0.744,5.265-0.119l3.036-3.063v-2.81 c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913l-3.036-1.753l-3.623,2.092v2.81l1.241,0.717 c-0.355,0.551-0.535,1.1-0.533,1.639c0.002,0.467,0.005,2.334,0.004,2.805c-0.003,1.161,0.832,2.28,2.58,3.289 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.014,0.669,0.011,1.001-0.004c1.895-0.09,3.711-0.597,5.374-1.161 c0.356-0.119,0.703-0.24,1.046-0.36l-3.056,3.064v2.81c4.314,1.729,8.526,0.908,11.708-0.507l2.998,1.731l3.623-2.092v-2.81 l-1.244-0.718C238.841,425.168,239.051,424.555,239.048,423.952z M231.407,423.71c-0.278,0.161-0.56,0.301-0.841,0.421 c-2.154,0.922-4.374,0.725-5.924,0.088c2.837-1,5.206-1.876,7.225-0.801C231.725,423.515,231.574,423.613,231.407,423.71z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000104688026668025914410000008539861739176539042_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000109015507213474817060000002803718313970241935_",
    style: {
      fill: "#00AB55"
    },
    d: "M227.071,416.935 c-0.009,0.002-0.016,0.002-0.025,0.004c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164 c-0.003,0.002-0.003,0.002-0.006,0.004c-0.653,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514 c-1.166-0.673-1.335-1.659,0.359-2.771c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493 c1.845-0.78,3.62-0.744,5.265-0.119l3.036-3.063c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913 l-3.036-1.753l-3.623,2.092l3.001,1.733c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.015,0.669,0.011,1-0.004c1.895-0.09,3.711-0.598,5.374-1.161 c3.477-1.162,6.294-2.532,8.635-1.181c1.57,0.906,1.135,2.045-0.588,3.04c-0.278,0.161-0.56,0.301-0.841,0.421 c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191c4.314,1.729,8.526,0.908,11.708-0.507l2.998,1.731l3.623-2.092 l-2.998-1.731c3.014-2.332,3.361-4.872-0.159-6.933c-0.019-0.014-0.041-0.027-0.059-0.038 C233.283,415.959,229.997,416.199,227.071,416.935z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103227365517426779830000004896231482859690370_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000141423845646592343340000000785702892226165165_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.071,416.935 c-0.009,0.002-0.016,0.002-0.025,0.004c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164 c-0.003,0.002-0.003,0.002-0.006,0.004c-0.653,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514 c-1.166-0.673-1.335-1.659,0.359-2.771c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493 c1.845-0.78,3.62-0.744,5.265-0.119l3.036-3.063c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913 l-3.036-1.753l-3.623,2.092l3.001,1.733c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.015,0.669,0.011,1-0.004c1.895-0.09,3.711-0.598,5.374-1.161 c3.477-1.162,6.294-2.532,8.635-1.181c1.57,0.906,1.135,2.045-0.588,3.04c-0.278,0.161-0.56,0.301-0.841,0.421 c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191c4.314,1.729,8.526,0.908,11.708-0.507l2.998,1.731l3.623-2.092 l-2.998-1.731c3.014-2.332,3.361-4.872-0.159-6.933c-0.019-0.014-0.041-0.027-0.059-0.038 C233.283,415.959,229.997,416.199,227.071,416.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000066515752481465728490000010601961409204683671_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: " 208.689,413.127 212.347,411.469 215.348,412.788 212.312,411.035  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173861645315613463080000011055754835530883509_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M217.566,411.99 c1.954-0.423,5.115-0.543,7.788,0.263l-2.103,2.986l3.036-3.062C223.055,411.145,220.192,411.216,217.566,411.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181065822146212370960000002715777678946064772_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M236.463,417.795c0.019,0.011,0.041,0.024,0.059,0.038c3.52,2.061,3.173,4.601,0.159,6.933c2.67-2.91,2.189-4.939-0.713-6.614 c-2.895-1.671-6.603-1.653-8.898-1.217C229.997,416.199,233.283,415.959,236.463,417.795z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000003821854838079178050000016216811520518133685_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: " 236.682,424.766 238.98,426.532 236.057,428.589 239.68,426.497  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101099490025832488740000001947255105217174712_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M230.566,424.13 c-3.183,1.509-5.775,0.504-5.775,0.504l-3.442,2.731l3.183-3.191C226.086,424.847,228.362,425.074,230.566,424.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000137837275399687822180000002646879517193538210_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M219.774,419.195c-1.369,0.538-3.342,0.446-4.339-0.412c-1.047-0.901-0.375-1.866,1.188-2.704 c-1.695,1.112-1.526,2.098-0.359,2.771c0.547,0.316,1.11,0.478,1.723,0.514C218.533,419.399,219.121,419.334,219.774,419.195z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160151731238138276300000004130869339377836696_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M211.661,414.883c-0.256,0.227-2.437,2.26-1.475,4.293c1.022,2.168,4.219,3.559,6.799,3.839l-0.003,0.002 c-1.635-0.06-3.314-0.466-5.002-1.44C208.553,419.598,208.616,417.197,211.661,414.883z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coin_00000176002915601192159410000010017466221300783253_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000146489000773738300880000018337502445030669733_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1481_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1578_",
    style: {
      fill: "#00AB55"
    },
    d: "M249.839,407.822c-1.711-2.887-4.556-5.599-8.544-7.902 c-13.97-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932v7.308h0.025 c0.257,5.081,3.735,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0c6.717-3.878,10.22-8.915,10.477-13.997v0v-7.308 H249.839z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1489_",
    style: {
      opacity: 0.25
    },
    d: "M249.839,407.822c-1.711-2.887-4.556-5.599-8.544-7.902 c-13.97-8.065-36.618-8.065-50.588,0c-3.989,2.303-6.834,5.015-8.545,7.902h-1.932v7.308h0.025 c0.257,5.081,3.735,10.118,10.452,13.996c13.969,8.065,36.618,8.065,50.588,0c6.717-3.878,10.22-8.915,10.477-13.997v0v-7.308 H249.839z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1488_",
    style: {
      opacity: 0.1
    },
    d: "M216.002,393.871c-9.155,0-18.311,2.016-25.296,6.049 c-3.989,2.303-6.834,5.015-8.545,7.902h-1.933v7.308h0.025c0.258,5.081,3.735,10.118,10.452,13.996 c6.985,4.033,16.141,6.049,25.296,6.049V393.871z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1487_",
    style: {
      opacity: 0.1
    },
    d: "M196.464,397.224c-2.036,0.768-3.969,1.664-5.757,2.696 c-3.989,2.303-6.834,5.015-8.545,7.902h-1.933v7.308h0.025c0.258,5.081,3.735,10.118,10.452,13.996 c1.788,1.032,3.721,1.928,5.757,2.697V397.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070111939579698687200000010224096504578254771_",
    style: {
      opacity: 0.5,
      fill: "#00AB55"
    },
    d: "M235.537,397.224 c2.036,0.768,3.969,1.664,5.757,2.696c3.989,2.303,6.834,5.015,8.544,7.902h1.933v7.308v0 c-0.258,5.081-3.76,10.118-10.477,13.997c-1.788,1.032-3.722,1.928-5.757,2.696V397.224z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093862272411855920340000015994792163149998986_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1470_",
    style: {
      fill: "#00AB55"
    },
    d: "M190.706,393.222c-13.97,8.065-13.968,21.142,0,29.207 c12.223,7.057,31.09,7.94,44.975,2.647l0.002-0.001c0.185-0.071,0.369-0.142,0.554-0.216 c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.804-24.819c-0.002-0.003-0.004-0.004-0.004-0.004 c-1.547-1.569-3.481-3.045-5.8-4.384C227.326,385.158,204.676,385.157,190.706,393.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1463_",
    style: {
      opacity: 0.2
    },
    d: "M190.706,393.222c-13.97,8.065-13.968,21.142,0,29.207 c12.223,7.057,31.09,7.94,44.975,2.647l0.002-0.001c0.185-0.071,0.369-0.142,0.554-0.216 c1.778-0.707,3.473-1.516,5.057-2.431c11.649-6.726,13.585-16.935,5.804-24.819c-0.002-0.003-0.004-0.004-0.004-0.004 c-1.547-1.569-3.481-3.045-5.8-4.384C227.326,385.158,204.676,385.157,190.706,393.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1431_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M247.097,397.61c0.15,0.169,5.036,5.324,3.741,12.742 c-1.237,7.098-11.176,13.072-14.601,14.507c1.778-0.707,3.473-1.516,5.057-2.431 C252.943,415.703,254.879,405.494,247.097,397.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1429_",
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    d: "M184.904,418.041c-0.15-0.169-5.036-5.324-3.741-12.742 c1.237-7.098,11.176-13.072,14.602-14.508c-1.778,0.707-3.473,1.516-5.057,2.431 C179.058,399.949,177.122,410.158,184.904,418.041z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1395_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#00AB55"
    },
    cx: 216.014,
    cy: 407.797,
    rx: 33.252,
    ry: 19.198
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    cx: 216.014,
    cy: 407.797,
    rx: 33.252,
    ry: 19.198
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1425_",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M184.272,413.531c-2.673-4.94-1.801-10.386,2.611-15.005 c0.816-0.854,1.757-1.679,2.817-2.467c0.822-0.616,1.723-1.208,2.692-1.774c0.531-0.31,1.075-0.606,1.638-0.888 c-1.382,2.274-0.875,4.711,6.956,5.168c15.326,0.895-4.096,15.542-4.096,15.542S187.011,409.336,184.272,413.531z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093896723523682461760000007710220840462018703_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M185.853,409.48 c-2.3-0.258-3.44-2.623-2.546-5.283c0.894-2.66,3.483-4.608,5.783-4.35c2.3,0.258,3.44,2.623,2.546,5.283 C190.742,407.789,188.153,409.737,185.853,409.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000036967860311541394730000000619562925727131058_",
    style: {
      fill: "#00AB55"
    },
    d: "M210.095,421.686 c0.755-5.691,25.633-21.447,25.633-21.447s5.517-2.214,3.685-6.07c0.957,0.549,1.844,1.123,2.661,1.72 c0.575,0.415,1.113,0.841,1.617,1.28c7.406,6.413,7.416,14.838-0.003,21.258c-0.5,0.437-1.041,0.865-1.613,1.281 c-0.763,0.556-1.582,1.09-2.467,1.605c-0.844,0.495-1.726,0.953-2.636,1.381c-0.725,0.343-1.479,0.666-2.242,0.966 c-0.76,0.302-1.538,0.581-2.332,0.841c-2.364,0.776-4.858,1.368-7.422,1.783c-0.553,0.089-1.113,0.17-1.669,0.242 c-2.445,0.314-4.93,0.471-7.422,0.466c-3.058-0.006-6.115-0.254-9.079-0.745C206.805,426.246,210.806,425.428,210.095,421.686z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1413_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M210.095,421.686c0.755-5.691,25.633-21.447,25.633-21.447 s5.517-2.214,3.685-6.07c0.957,0.549,1.844,1.123,2.661,1.72c0.575,0.415,1.113,0.841,1.617,1.28 c7.406,6.413,7.416,14.838-0.003,21.258c-0.5,0.437-1.041,0.865-1.613,1.281c-0.763,0.556-1.582,1.09-2.467,1.605 c-0.844,0.495-1.726,0.953-2.636,1.381c-0.725,0.343-1.479,0.666-2.242,0.966c-0.76,0.302-1.538,0.581-2.332,0.841 c-2.364,0.776-4.858,1.368-7.422,1.783c-0.553,0.089-1.113,0.17-1.669,0.242c-2.445,0.314-4.93,0.471-7.422,0.466 c-3.058-0.006-6.115-0.254-9.079-0.745C206.805,426.246,210.806,425.428,210.095,421.686z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1399_",
    style: {
      fill: "#00AB55"
    },
    d: "M233.542,397.683c9.28,5.358,9.656,13.906,1.132,19.525 c-0.362,0.238-0.742,0.474-1.136,0.702c-9.675,5.586-25.355,5.586-35.03,0s-9.678-14.641-0.004-20.227 c0.394-0.227,0.803-0.447,1.216-0.656C209.454,392.106,224.262,392.325,233.542,397.683z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1396_",
    style: {
      opacity: 0.2
    },
    d: "M233.542,397.683c9.28,5.358,9.656,13.906,1.132,19.525 c-0.362,0.238-0.742,0.474-1.136,0.702c-9.675,5.586-25.355,5.586-35.03,0s-9.678-14.641-0.004-20.227 c0.394-0.227,0.803-0.447,1.216-0.656C209.454,392.106,224.262,392.325,233.542,397.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M232.756,398.129c9.247,5.339,9.247,13.995,0,19.334c-9.247,5.339-24.24,5.339-33.488,0 c-9.247-5.339-9.247-13.995,0-19.334C208.516,392.79,223.509,392.79,232.756,398.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M232.756,398.129c9.247,5.339,9.247,13.995,0,19.334c-9.247,5.339-24.24,5.339-33.488,0 c-9.247-5.339-9.247-13.995,0-19.334C208.516,392.79,223.509,392.79,232.756,398.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M232.756,401.943c-9.247-5.339-24.24-5.339-33.488,0c-3.782,2.183-6.014,4.921-6.703,7.76 c0.689,2.839,2.922,5.577,6.703,7.76c9.247,5.339,24.24,5.339,33.487,0c3.782-2.183,6.015-4.921,6.703-7.76 C238.77,406.864,236.537,404.126,232.756,401.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35
    },
    d: "M232.756,401.943c-9.247-5.339-24.24-5.339-33.488,0c-3.782,2.183-6.014,4.921-6.703,7.76 c0.689,2.839,2.922,5.577,6.703,7.76c9.247,5.339,24.24,5.339,33.487,0c3.782-2.183,6.015-4.921,6.703-7.76 C238.77,406.864,236.537,404.126,232.756,401.943z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M230.924,411.914c-0.002-0.461,0.006-2.342,0.002-2.826c-0.009-1.159-0.803-2.283-2.528-3.293 c-0.019-0.014-0.041-0.027-0.06-0.038c-3.18-1.836-6.465-1.596-9.392-0.859c-0.009,0.002-0.016,0.002-0.025,0.004 c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164c-0.003,0.002-0.003,0.002-0.006,0.004 c-0.654,0.139-1.241,0.204-1.788,0.17c-0.523-0.031-1.009-0.161-1.481-0.393c0.04-0.027,0.076-0.055,0.118-0.082 c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.355,0.991-0.493c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063v-2.81 c-2.698-0.915-5.502-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913l-3.036-1.753l-3.624,2.092v2.81l1.241,0.717 c-0.355,0.551-0.535,1.1-0.533,1.639c0.002,0.467,0.005,2.334,0.004,2.805c-0.003,1.161,0.832,2.28,2.58,3.289 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.015,0.669,0.011,1.001-0.004c1.895-0.09,3.711-0.597,5.374-1.161 c0.356-0.119,0.703-0.24,1.046-0.36l-3.056,3.064v2.81c4.314,1.729,8.526,0.908,11.709-0.507l2.998,1.731l3.623-2.092v-2.81 l-1.244-0.718C230.717,413.131,230.927,412.518,230.924,411.914z M223.284,411.673c-0.278,0.161-0.559,0.301-0.841,0.421 c-2.154,0.922-4.374,0.725-5.924,0.088c2.837-1,5.206-1.876,7.225-0.801C223.602,411.478,223.451,411.576,223.284,411.673z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1388_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168083709449170199160000005053496979068343726_",
    style: {
      fill: "#00AB55"
    },
    d: "M218.948,404.898 c-0.01,0.002-0.016,0.002-0.025,0.004c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164 c-0.003,0.002-0.003,0.002-0.006,0.004c-0.654,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514 c-1.166-0.673-1.335-1.659,0.36-2.771c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493 c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913 l-3.036-1.753l-3.624,2.092l3.001,1.733c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693 c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002c0.331,0.014,0.669,0.011,1-0.003c1.895-0.09,3.711-0.598,5.374-1.161 c3.477-1.163,6.294-2.533,8.635-1.181c1.569,0.906,1.135,2.045-0.588,3.04c-0.278,0.161-0.559,0.301-0.841,0.421 c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191c4.314,1.729,8.526,0.908,11.708-0.507l2.998,1.731l3.623-2.092 l-2.998-1.731c3.014-2.332,3.361-4.872-0.16-6.933c-0.019-0.014-0.041-0.027-0.059-0.038 C225.16,403.922,221.874,404.162,218.948,404.898z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1364_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1384_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M218.948,404.898c-0.01,0.002-0.016,0.002-0.025,0.004 c-1.244,0.314-2.426,0.718-3.505,1.088c-1.491,0.518-2.714,0.939-3.761,1.164c-0.003,0.002-0.003,0.002-0.006,0.004 c-0.654,0.139-1.241,0.204-1.788,0.17c-0.613-0.036-1.176-0.199-1.723-0.514c-1.166-0.673-1.335-1.659,0.36-2.771 c0.116-0.078,0.241-0.153,0.372-0.229c0.331-0.191,0.66-0.356,0.991-0.493c1.844-0.78,3.62-0.744,5.265-0.119l3.036-3.063 c-2.698-0.915-5.503-1.011-8.301-0.301c-0.882,0.224-1.763,0.531-2.639,0.913l-3.036-1.753l-3.624,2.092l3.001,1.733 c0,0-0.009,0.009-0.028,0.023c-3.045,2.314-3.108,4.715,0.319,6.693c1.688,0.975,3.367,1.381,5.002,1.44l0.003-0.002 c0.331,0.014,0.669,0.011,1-0.003c1.895-0.09,3.711-0.598,5.374-1.161c3.477-1.163,6.294-2.533,8.635-1.181 c1.569,0.906,1.135,2.045-0.588,3.04c-0.278,0.161-0.559,0.301-0.841,0.421c-2.204,0.944-4.48,0.717-6.034,0.043l-3.183,3.191 c4.314,1.729,8.526,0.908,11.708-0.507l2.998,1.731l3.623-2.092l-2.998-1.731c3.014-2.332,3.361-4.872-0.16-6.933 c-0.019-0.014-0.041-0.027-0.059-0.038C225.16,403.922,221.874,404.162,218.948,404.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000164511183427753121400000003479622389223762567_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: " 200.566,401.09 204.223,399.432 207.224,400.751 204.188,398.998  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M209.442,399.953c1.954-0.424,5.115-0.543,7.788,0.263 l-2.103,2.986l3.036-3.062C214.931,399.108,212.069,399.178,209.442,399.953z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000089536370023123361710000012510729592158578861_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: " M228.339,405.758c0.019,0.011,0.041,0.023,0.059,0.038c3.52,2.061,3.173,4.601,0.16,6.933c2.67-2.91,2.189-4.938-0.713-6.614 c-2.895-1.672-6.603-1.653-8.898-1.217C221.874,404.162,225.16,403.922,228.339,405.758z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1283_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    points: "228.558,412.728 230.857,414.495 227.933,416.552  231.556,414.46  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1282_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M222.443,412.093c-3.183,1.509-5.775,0.504-5.775,0.504 l-3.442,2.731l3.183-3.191C217.963,412.81,220.239,413.037,222.443,412.093z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000100343528343843476970000000542236909882622870_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M211.65,407.158 c-1.369,0.538-3.342,0.447-4.339-0.412c-1.047-0.901-0.375-1.866,1.188-2.704c-1.695,1.112-1.526,2.097-0.36,2.771 c0.547,0.316,1.11,0.478,1.723,0.514C210.409,407.362,210.997,407.297,211.65,407.158z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1271_",
    style: {
      opacity: 0.45,
      fill: "#F5F5F5"
    },
    d: "M203.537,402.846c-0.256,0.227-2.438,2.26-1.475,4.293 c1.022,2.168,4.219,3.559,6.799,3.839l-0.003,0.002c-1.635-0.06-3.314-0.466-5.002-1.44 C200.43,407.561,200.492,405.16,203.537,402.846z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000067938266104530296520000008723836425605707193_",
    style: {
      fill: "#FFFFFF"
    },
    points: "184.406,404.186  185.308,397.343 186.21,404.186 198.062,404.707 186.21,405.227 185.308,412.07 184.406,405.227 172.553,404.707  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Bar_graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bar_graph_00000128445088429163182100000015566493697034198199_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M398.773,418.082c-0.051,0-0.103-0.013-0.149-0.04l-19.364-11.18 c-0.092-0.053-0.149-0.151-0.149-0.258c0-0.107,0.057-0.205,0.149-0.258l24.206-13.975c0.093-0.054,0.206-0.054,0.298,0 l19.364,11.18c0.092,0.053,0.148,0.151,0.148,0.258c0,0.107-0.057,0.205-0.148,0.258l-24.205,13.975 C398.876,418.069,398.824,418.082,398.773,418.082z M380.005,406.605l18.768,10.836l23.609-13.631l-18.768-10.836 L380.005,406.605z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_886_",
    style: {
      fill: "#00AB55"
    },
    points: "398.773,414.99 398.771,314.764 384.248,306.379 384.25,406.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_558_",
    style: {
      opacity: 0.2
    },
    points: "398.773,414.99 398.771,314.764 384.248,306.379 384.25,406.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_885_",
    style: {
      fill: "#00AB55"
    },
    points: "398.773,414.99 418.137,403.81 418.14,303.586 398.771,314.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000005944782037607821150000014641838378737943442_",
    style: {
      fill: "#00AB55"
    },
    points: "418.14,303.586  403.617,295.201 384.248,306.379 398.771,314.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_559_",
    style: {
      opacity: 0.25,
      fill: "#FFFFFF"
    },
    points: "418.14,303.586 403.617,295.201 384.248,306.379  398.771,314.764  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M418.14,303.585l-19.561,10.783l-6.353-3.546l-7.979-4.443l7.837,4.689l6.424,3.835 c-0.152,2.18-0.194,91.228-0.164,93.408c0.033,2.227,0.137,4.453,0.428,6.679c0.29-2.226,0.393-4.453,0.425-6.68 c0.028-2.111-0.013-91.088-0.154-93.198L418.14,303.585z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M362.466,439.045c-0.051,0-0.103-0.013-0.149-0.04l-19.364-11.18 c-0.092-0.053-0.148-0.151-0.148-0.258c0-0.106,0.057-0.205,0.148-0.258l24.206-13.974c0.093-0.053,0.205-0.053,0.298,0 l19.364,11.18c0.092,0.053,0.149,0.151,0.149,0.258c0,0.107-0.057,0.205-0.149,0.258l-24.205,13.975 C362.568,439.032,362.517,439.045,362.466,439.045z M343.697,427.567l18.768,10.836l23.609-13.631l-18.767-10.835 L343.697,427.567z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000084492773739996765280000011941234846098014107_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3658_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000057115321808720448980000007173842863637717419_",
    style: {
      fill: "#00AB55"
    },
    points: "362.466,435.952  362.463,375.819 347.94,367.434 347.943,427.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000121258594741848386310000015962153139727514033_",
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: " 362.466,435.952 362.463,375.819 347.94,367.434 347.943,427.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000135672586008862475340000004454967143530721469_",
    style: {
      fill: "#00AB55"
    },
    points: "362.466,435.952  381.83,424.772 381.832,364.64 362.463,375.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000120536508862016053060000000565386069325954237_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: " 362.466,435.952 381.83,424.772 381.832,364.64 362.463,375.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3661_",
    style: {
      fill: "#00AB55"
    },
    points: "381.832,364.64 367.309,356.255 347.94,367.434 362.463,375.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000082368146354387424790000001299597719877093513_",
    style: {
      opacity: 0.55,
      fill: "#FFFFFF"
    },
    points: " 381.832,364.64 367.309,356.255 347.94,367.434 362.463,375.819  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M362.721,376.176l19.111-11.536l-19.564,10.785c-2.109-1.195-4.23-2.37-6.349-3.548 l-7.979-4.443l7.837,4.689c2.142,1.283,4.281,2.57,6.434,3.835c-0.068,2.261-0.138,13.168-0.159,15.428 c-0.023,2.307-0.033,28.417-0.014,30.724c0.013,2.307,0.051,4.614,0.128,6.921c0.058,2.307,0.152,4.614,0.3,6.921 c0.148-2.307,0.241-4.614,0.299-6.921c0.076-2.307,0.114-4.614,0.126-6.921c0.018-2.307,0.007-28.417-0.016-30.724 C362.854,389.198,362.787,378.364,362.721,376.176z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M326.158,460.007c-0.051,0-0.103-0.013-0.149-0.04l-19.364-11.18 c-0.092-0.053-0.149-0.151-0.149-0.258c0-0.107,0.057-0.205,0.149-0.258l24.206-13.975c0.093-0.053,0.205-0.053,0.298,0 l19.364,11.18c0.092,0.053,0.149,0.151,0.149,0.258c0,0.107-0.057,0.205-0.149,0.258l-24.205,13.975 C326.261,459.994,326.209,460.007,326.158,460.007z M307.39,448.53l18.768,10.836l23.609-13.631l-18.768-10.836L307.39,448.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119103264228319126750000004256423887361539457_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000097502185351330587750000009806445730830038679_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000008151167679861838870000017822691223953342336_",
    style: {
      fill: "#00AB55"
    },
    points: "326.158,456.914  326.155,435.782 311.633,427.397 311.635,448.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000177455956696190525740000011578264176838261410_",
    style: {
      opacity: 0.45
    },
    points: "326.158,456.914  326.155,435.782 311.633,427.397 311.635,448.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000060730504564643589180000009780291934650644623_",
    style: {
      fill: "#00AB55"
    },
    points: "326.158,456.914  345.522,445.735 345.525,424.603 326.155,435.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_775_",
    style: {
      opacity: 0.3
    },
    points: "326.158,456.914 345.522,445.735 345.525,424.603 326.155,435.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000098903267627467072430000002876318151378135723_",
    style: {
      fill: "#00AB55"
    },
    points: "345.525,424.603  331.001,416.218 311.633,427.397 326.155,435.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000041289532293999779310000013061537540966977717_",
    style: {
      opacity: 0.15
    },
    points: "345.525,424.603  331.001,416.218 311.633,427.397 326.155,435.782  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M345.525,424.603l-19.561,10.783l-6.353-3.546l-7.979-4.443l7.837,4.689l6.42,3.832 c-0.148,1.327-0.189,15.552-0.159,16.879c0.033,1.373,0.137,2.745,0.428,4.118c0.29-1.373,0.393-2.745,0.425-4.118 c0.027-1.259-0.011-15.415-0.142-16.674L345.525,424.603z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M435.081,397.12c-0.051,0-0.103-0.013-0.149-0.04l-19.364-11.18 c-0.092-0.053-0.149-0.151-0.149-0.258c0-0.107,0.057-0.205,0.149-0.258l24.206-13.975c0.093-0.053,0.205-0.053,0.298,0 l19.364,11.18c0.092,0.053,0.149,0.151,0.149,0.258c0,0.107-0.057,0.205-0.149,0.258L435.23,397.08 C435.184,397.107,435.132,397.12,435.081,397.12z M416.313,385.643l18.768,10.836l23.61-13.631l-18.768-10.836L416.313,385.643z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4543_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4554_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4557_",
    style: {
      fill: "#00AB55"
    },
    points: "435.081,394.028 435.078,255.288 420.556,246.903 420.558,385.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000029020740056547534980000012792703969235730876_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: " 435.081,394.028 435.078,255.288 420.556,246.903 420.558,385.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4556_",
    style: {
      fill: "#00AB55"
    },
    points: "435.081,394.028 454.445,382.848 454.448,244.109 435.078,255.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_787_",
    style: {
      opacity: 0.55,
      fill: "#FFFFFF"
    },
    points: "435.081,394.028 454.445,382.848 454.448,244.109  435.078,255.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4555_",
    style: {
      fill: "#00AB55"
    },
    points: "454.448,244.109 439.924,235.724 420.556,246.903 435.078,255.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000174568663065387220200000013053754534446425780_",
    style: {
      opacity: 0.75,
      fill: "#FFFFFF"
    },
    points: " 454.448,244.109 439.924,235.724 420.556,246.903 435.078,255.288  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M435.335,255.646l19.113-11.536l-19.564,10.785c-2.109-1.195-4.23-2.37-6.349-3.548 l-7.979-4.443l7.837,4.689c2.142,1.283,4.281,2.57,6.434,3.835c-0.068,2.562-0.139,34.696-0.159,37.258 c-0.023,2.608-0.033,83.084-0.014,85.692c0.013,2.608,0.051,5.217,0.127,7.825c0.058,2.608,0.152,5.217,0.3,7.825 c0.148-2.608,0.241-5.217,0.299-7.825c0.076-2.608,0.114-5.217,0.126-7.825c0.019-2.608,0.008-83.084-0.016-85.692 C435.47,290.196,435.401,258.135,435.335,255.646z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Triangles_00000040542990165861373990000015222869501995311253_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangles"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#00AB55"
    },
    points: "97.971,169.841 41.87,202.231 69.922,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#00AB55"
    },
    points: "97.971,193.397 41.87,225.787 69.922,174.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.15,
      fill: "#00AB55"
    },
    points: "97.971,216.953 41.87,249.343 69.922,197.812  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_00000138571629387104383730000007548711603390958738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_10_",
    style: {
      opacity: 0.2
    },
    d: "M225.514,284.067c4.468-3.852,10.393-7.465,17.605-10.736 c8.106-3.676,17.852-6.934,24.62-10.932c8.795-5.196,12.148-11.459,11.506-17.761c-0.363-3.569-2.49-7.527-10.603-10.157 c-2.077-0.673-4.608-1.249-7.334-1.381c-4.003-0.194-7.473,0.59-10.267,1.435c-14.906,4.511-21.235,11.442-26.235,18.177 c-5.001,6.734-11.074,10.637-21.989,16.984c-4.671,2.716-9.682,5.375-14.094,8.125c-0.036,0.022-0.071,0.044-0.107,0.067 c-2.228,1.397-4.683,2.692-6.438,4.191c-2.799,2.391-5.263,4.857-6.271,7.467c-1.008,2.61-0.505,5.387,2.471,7.986 c0.766,0.669,1.763,1.355,3.465,1.81c1.441,0.385,3.245,0.563,4.987,0.622c3.55,0.12,6.98-0.217,9.879-0.785 c2.899-0.568,5.316-1.357,7.547-2.19C213.985,293.359,220.179,288.666,225.514,284.067z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Character_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm_00000090267331252223168050000014042855622765582501_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M179.801,151.349c-0.817,2.168-3.197,6.773-3.048,7.354c0.406,1.59,0.485,2.56,0.134,4.415 c-0.21,1.109-9.803,4.88-9.803,4.88l-0.233-1.517c-0.157-1.023-0.029-2.067,0.379-3.018c1.111-2.594,3.38-8.266,4.087-12.847 L179.801,151.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M177.038,162.144l-10.151,4.564l0.198,1.291c0,0,9.593-3.771,9.803-4.88 C176.954,162.762,177.001,162.445,177.038,162.144z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Briefcase_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_635_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1162_",
    style: {
      fill: "#37474F"
    },
    d: "M146.253,181.659l-3.051,31.339c-0.148,1.519,0.841,2.502,2.079,3.403 l3.111,2.226c0.859,0.616,1.349,0.842,2.525,0.757c0.514-0.033,1.404-0.363,1.83-0.55c0.028-0.004,0.05-0.016,0.072-0.028 l0.188-0.085l35.579-16.169c2.6-1.182,4.371-3.66,4.648-6.502l2.779-28.536c0.063-0.649-0.319-1.491-0.85-1.87l-5.313-3.794 c-0.529-0.383-1.446-0.473-2.039-0.199l-40.36,18.342c-0.303,0.13-0.584,0.392-0.799,0.689 C146.436,180.986,146.284,181.337,146.253,181.659z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1019_",
    style: {
      fill: "#263238"
    },
    d: "M146.253,181.659l-3.051,31.339c-0.148,1.519,0.841,2.502,2.079,3.403 l3.111,2.226c0.859,0.616,1.349,0.842,2.525,0.757c0.514-0.033,1.404-0.363,1.83-0.55l0.001-0.013 c-1.373,0.487-2.341-0.297-2.189-1.851l2.875-29.528c0.048-0.493,0.273-1.024,0.601-1.482l-7.382-5.278 C146.436,180.986,146.284,181.337,146.253,181.659z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M153.432,187.442c0.095-0.983,0.909-2.12,1.807-2.528l38.146-17.336 c1.508-0.685,2.61,0.103,2.45,1.751l-2.599,26.717c-0.276,2.843-2.049,5.322-4.649,6.504l-35.58,16.17 c-1.508,0.685-2.61-0.102-2.45-1.751L153.432,187.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M194.372,168.831c-0.026,0.038-0.011,0.164-0.029,0.353l-2.598,26.718 c-0.224,2.302-1.671,4.326-3.778,5.284l-35.58,16.171c-0.174,0.079-0.293,0.104-0.359,0.111 c0.017-0.04,0.002-0.165,0.021-0.352l2.875-29.528c0.05-0.509,0.471-1.098,0.936-1.31l38.146-17.334 C194.188,168.86,194.309,168.837,194.372,168.831 M194.408,167.331c-0.308,0-0.653,0.079-1.022,0.248l-38.146,17.335 c-0.898,0.408-1.712,1.546-1.807,2.528l-2.875,29.528c-0.122,1.245,0.477,1.999,1.427,1.999c0.308,0,0.653-0.08,1.023-0.248 l35.581-16.171c2.599-1.182,4.372-3.661,4.649-6.504l2.598-26.717C195.955,168.085,195.357,167.331,194.408,167.331 L194.408,167.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M191.571,163.079l-40.452,18.593c-1.163,0.534-1.954,1.646-2.078,2.92l-3.14,32.253 l0.55,0.394l3.173-32.591c0.103-1.062,0.77-1.998,1.739-2.444l40.757-18.733L191.571,163.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M149.692,182.855c-0.36,0.505-0.589,1.101-0.651,1.736l-3.14,32.254l0.55,0.394l3.173-32.591 c0.051-0.531,0.243-1.029,0.544-1.451L149.692,182.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M150.168,183.197c0.301-0.423,0.71-0.769,1.195-0.993l40.757-18.733l-0.549-0.392 l-40.452,18.593c-0.579,0.266-1.068,0.679-1.427,1.183"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000102532883198572060800000017332711680317758396_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_632_",
    style: {
      fill: "#00AB55"
    },
    d: "M177.584,165.76l-0.472,4.853l1.791,1.281l0.628-6.445 c0.032-0.33-0.189-0.488-0.49-0.351L177.584,165.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1256_",
    style: {
      opacity: 0.4
    },
    d: "M177.584,165.76l-0.472,4.853l1.791,1.281l0.628-6.445 c0.032-0.33-0.189-0.488-0.49-0.351L177.584,165.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_630_",
    style: {
      fill: "#00AB55"
    },
    d: "M163.78,169.257l-0.765,7.856l1.71,1.225l1.288-0.587l0.628-6.444 c0.032-0.331,0.306-0.714,0.609-0.851l9.762-4.435l2.028-0.922c0.302-0.137,0.523,0.02,0.491,0.351l-0.628,6.444l1.292-0.587 l0.764-7.854c0.003-0.033,0.004-0.069,0.001-0.103c-0.009-0.313-0.193-0.676-0.437-0.849l-0.728-0.523 c-0.269-0.193-0.735-0.239-1.04-0.101l-14.369,6.529C164.082,168.546,163.812,168.927,163.78,169.257z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    style: {
      opacity: 0.2
    },
    d: "M165.489,170.482l-0.764,7.857l1.288-0.587l0.628-6.444 c0.032-0.331,0.306-0.714,0.609-0.851l9.762-4.435l2.028-0.922c0.302-0.137,0.523,0.02,0.491,0.351l-0.628,6.444l1.292-0.587 l0.764-7.854c0.003-0.033,0.004-0.069,0.001-0.103c-0.02-0.26-0.225-0.37-0.495-0.248l-14.369,6.529 C165.795,169.771,165.521,170.152,165.489,170.482z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M175.48,165.398c0.21,0.007,0.413,0.068,0.581,0.196c0.262-0.44,0.769-0.723,1.281-0.714 c0.225,0.004,0.486,0.095,0.544,0.312c0.019,0.072,0.013,0.148,0.006,0.223c-0.069,0.723-0.169,1.443-0.298,2.157 c-0.094,0.516-0.225,1.069-0.621,1.413c-0.325,0.282-0.804,0.372-1.209,0.227c-0.146,0.342-0.442,0.61-0.785,0.748 c-0.08,0.032-1.089,0.12-1.027,0.002c-0.379,0.709-1.215,1.439-2.295,1.224c0,0-0.269,0.776-1.693,0.609 c-1.425-0.167-2.055-1.738-2.055-1.738c0.08-0.439,0.231-0.615,0.721-0.805c0.243-0.094,0.504-0.203,0.736-0.319 c0.335-0.167,0.552-0.556,0.793-0.84c0.246-0.289,0.531-0.562,0.886-0.698c0.355-0.135,0.794-0.106,1.07,0.154 c0.032-0.294,0.229-0.541,0.433-0.755c0.184-0.192,0.413-0.384,0.688-0.413c0.081-0.008,0.731,0.105,0.652,0.275 c0.195-0.421,0.466-0.825,0.863-1.064C174.968,165.46,175.228,165.389,175.48,165.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M181.229,150.617c-0.621,2.871-2.182,5.45-1.488,7.862c0.468,1.63,0.596,1.463,0.407,3.124 c-0.07,0.616-0.322,1.592-0.533,2.175c-0.125,0.347-0.247,0.694-0.373,1.041c-0.132,0.364-0.266,0.731-0.457,1.068 c-0.246,0.435-0.584,0.812-0.904,1.19c-0.563,0.665-1.147,1.328-1.869,1.816c-0.039,0.026-0.08,0.049-0.125,0.063 c-0.179,0.059-0.383-0.023-0.51-0.162c-0.627-0.689-0.153-1.691,0.176-2.388c0.367-0.776,0.799-1.561,0.781-2.445 c-0.002-0.109-0.009-0.455,0.001-1.002c-0.005,0.002-0.887-0.22-0.887-0.22s-2.867-0.69-2.919-2.078 c-0.052-1.387,1.05-2.724,1.876-4.348c0.846-1.663,1.172-2.69,2.018-6.893L181.229,150.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M178.785,165.886c-0.653,1.064-1.489,2.012-2.425,2.839c-0.157,0.119-0.292,0.325-0.576,0.349 c-1.338-0.252-0.708-2.019-0.258-2.797c0.367-0.737,0.785-1.475,0.808-2.317c0.057,0.845-0.322,1.643-0.664,2.385 c-0.351,0.723-0.978,2.202,0.106,2.53C176.914,168.198,177.937,166.941,178.785,165.886L178.785,165.886z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M176.107,162.69c-0.349-0.178-0.732-0.309-1.063-0.523c-0.257-0.167-0.472-0.396-0.644-0.648 c-0.417-0.611-0.789-1.414-0.668-2.168c0.008-0.046-0.045-0.13-0.072-0.053c-0.307,0.849-0.071,1.815,0.386,2.569 c0.214,0.353,0.534,0.636,0.883,0.851c0.18,0.111,0.374,0.195,0.58,0.247c0.234,0.059,0.401,0.064,0.619-0.038 C176.207,162.89,176.173,162.723,176.107,162.69z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M198.274,93.047c-6.198-0.477-11.146,0.753-14.349,8.904c-3.618,9.206-7.18,16.307-8.973,23.006 c-1.794,6.698-4.444,27.887-4.444,27.887s4.683,4.078,9.835,2.218l7.799-24.083l10.132-19.488V93.047z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4947_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M268.64,245.088c0.434-0.302,1.067,0.815,1.082,1.512c0.043,2.002-1.304,4.933-4.225,7.526 c-2.921,2.593-9.928,5.351-11.946,6.377c-2.018,1.026-4.866,3.929-6.656,5.344c-3.262,2.577-6.27,2.953-8.085,2.455 c-0.712-0.195-1.129-0.837-1.434-1.419c-0.726-1.382-0.76-1.723-0.602-1.797L268.64,245.088z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4991_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4994_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4998_",
    style: {
      fill: "#455A64"
    },
    d: "M234.948,260.897c0.454,1.494,1.476,3.837,2.425,5.09 c0.98,0.783,2.411,0.741,3.455,0.524c2.754-0.573,4.973-1.996,7.245-3.985c1.362-1.192,2.849-2.485,4.761-3.419 c2.101-1.026,6.853-3.077,8.915-4.191c1.75-0.946,3.781-2.542,4.967-4.177c1.002-1.382,2.274-3.914,2.146-5.214 c-0.923-2.697-1.986-4.015-3.861-4.058c-1.98-0.045-4.207,0.971-7.276,2.391c-0.919,0.426-2.06,0.995-2.56,1.206 c-1.892,0.798-3.633,1.594-5.033,2.262c-1.199,0.572-2.38,1.12-3.738,1.131c-0.647,0.005-1.173-0.065-1.691-0.452 c-0.632-0.47-1.134-1.388-1.711-1.134c-0.001,0-9.128,7.338-9.898,7.876C232.207,255.37,233.573,256.373,234.948,260.897z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M255.894,244.536c0.403,0.031,0.929,0.273,1.236,0.468c0.421,0.266,0.771,0.551,1.116,0.912 c0.421,0.44-0.156,0.896-0.733,0.444c-0.395-0.31-0.823-0.671-1.504-0.997c-0.325-0.156-0.914-0.268-1.224-0.137 c-0.234,0.1-0.54,0.232-0.54,0.232C254.168,245,255.359,244.495,255.894,244.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M251.048,246.544c0.338-0.241,0.686-0.309,1.11-0.24c0.5,0.081,0.93,0.346,1.308,0.666 c0.307,0.26,1.02,0.966,1.254,1.296c0.222,0.31-0.563,0.734-0.848,0.42c-0.282-0.309-0.819-0.873-1.171-1.165 c-0.216-0.18-1.104-0.823-1.689-0.611l-0.25,0.121c-0.066-0.114,0.043-0.278,0.136-0.364 C250.945,246.622,250.995,246.581,251.048,246.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M248.335,247.954c0.31-0.054,0.489-0.114,0.782,0.012c0.275,0.119,0.647,0.352,0.862,0.566 c0.594,0.593,0.793,0.906,1.145,1.499c0.248,0.419-0.589,0.74-0.774,0.47c-0.584-0.852-0.912-1.439-1.704-1.857 c-0.653-0.344-1.061-0.329-1.061-0.329c-0.021-0.088,0.088-0.161,0.17-0.191C247.882,248.078,248.2,247.977,248.335,247.954z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4970_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M226.816,244.244c0,0,5.126,9.068,6.541,11.088 c0.452,0.646,1.899,0.198,2.728,0.116c0.828-0.082,2.137-0.21,3.028,0.04c2.634,0.739,4.131,0.421,3.507-3.098 c-0.128-0.72,0.115-1.199,0.969-1.488c0.638-0.217,1.37-0.288,1.887-0.73c0.057-0.108-0.074-0.216-0.184-0.271 c-0.846-0.413-1.324-0.707-1.914-1.986c-1.824-3.957-3.493-12.107-3.493-12.107L226.816,244.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M187.99,264.523c1.57-2.511,2.419-7.345,5.874-17.168l12.811,9.381l-7.338,14.307 c-0.417,0.717-0.432,1.796-0.578,2.006C197.047,275.509,187.99,264.523,187.99,264.523z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M183.245,269.879c0.019-0.145-0.058-1.329-0.021-1.471c0.333-1.275,1.121-1.627,2.132-2.339 c1.254-0.883,2.469-1.94,2.791-2.387c0.339-0.469,0.404-0.712,0.93-0.926c0.896-0.364,2.336-0.393,4.109,0.539 c2.906,1.526,3.794,3.365,3.626,5.357c-0.127,1.519-0.254,3.539,1.085,4.443c0.557,0.376,1.438-2.052,1.438-2.052 c0.826,1.384-0.334,3.3-0.939,6.104c-0.415,1.923-0.314,2.761-0.081,4.714c0.294,2.462,0.634,2.452,1.941,2.623 c1.126,0.148,4.319-0.066,6.261,1.29c2.677,1.87,1.962,4.357,1.962,4.357c-0.346,0.946-3.258,5.537-13.894,3.823 c-3.085-0.497-9.566-5.348-9.467-5.801c0.092-0.421-0.01-0.968-0.025-1.393c-0.037-1.088-0.084-2.175-0.131-3.262 c-0.043-0.991,0.058-2.144-0.181-3.107c-0.212-0.857-0.313-1.678-0.396-2.569c-0.204-2.183-0.407-4.367-0.611-6.55 C183.715,270.643,183.16,270.499,183.245,269.879z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4942_",
    style: {
      fill: "#263238"
    },
    d: "M181.905,269.448c-1.049,1.015-0.411,3.96,0.996,7.495 c0.624,1.568,1.786,4.267,1.445,7.136c-0.341,2.869-0.401,4.225,0.338,5.57c1.157,2.104,7.341,4.796,10.985,5.639 c0,0-3.339-4.191-3.705-10.525c-0.367-6.333-0.85-10.416-3.746-13.224C184.556,267.987,181.905,269.448,181.905,269.448z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4939_",
    style: {
      fill: "#37474F"
    },
    d: "M208.479,290.132c0,0-2.133,3.997-10.362,3.866 c-3.239-0.051-4.973-1.629-5.053-6.553c-0.096-5.934-0.574-11.927-2.493-14.873c-1.919-2.946-4.976-4.374-7.347-4.164 c-0.412,0.066-0.933,0.459-1.319,1.04c0,0,2.373-0.78,6.065,2.284c2.726,2.262,3.463,6.987,3.422,12.855 c-0.018,2.525-0.171,5.389,0.568,7.304c0.682,1.766,2.193,2.976,3.929,3.463c4.474,1.257,10.596-0.814,12.145-2.705 C208.923,291.388,208.479,290.132,208.479,290.132z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4938_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M198.593,283.407c0,0,0.6,0.424,0.666,0.982 c0.065,0.558-0.128,1.847-1.297,2.577c-0.495,0.309-0.927,0.201-0.14-0.839 C198.609,285.087,198.593,283.407,198.593,283.407z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4937_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M198.151,280.336c0,0,0.261,0.168,0.327,0.993 c0.035,0.442-0.653,2.223-1.519,2.648c-0.866,0.424-0.398-0.574-0.022-1.064 C197.349,282.375,198.075,281.153,198.151,280.336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4936_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M198.443,276.943c0,0,0.281,0.078-0.019,1.213 c-0.102,0.383-1.235,1.507-1.794,1.574c-0.558,0.067-0.829-0.212-0.144-0.709 C197.026,278.63,198.338,277.493,198.443,276.943z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4912_",
    style: {
      fill: "#37474F"
    },
    d: "M219.439,150.118c0,0,4.978,5.966,7.988,17.125 c3.654,13.546,5.068,23.965,6.21,31.526c0.719,4.75,1.406,9.332,3.06,18.466c1.571,8.68,5.474,27.459,5.474,27.459 s-0.686,2.862-4.548,4.552c-3.862,1.69-8.041,1.042-8.041,1.042s-2.648-4.523-8.169-15.178 c-3.746-7.229-4.363-11.166-5.088-14.866c-0.542-2.786-1.187-8.226-1.134-10.728l-20.723-35.213c0,0-2.222-2.313-4.158-7.174 c-2.929-7.353,0.811-17.947,0.811-17.947L219.439,150.118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000027568124663965352600000015272522397559046582_",
    style: {
      fill: "#37474F"
    },
    d: "M219.439,150.118 c0,0,4.978,5.966,7.988,17.125c3.654,13.546,5.068,23.965,6.21,31.526c0.719,4.75,1.406,9.332,3.06,18.466 c1.571,8.68,5.474,27.459,5.474,27.459s-0.686,2.862-4.548,4.552c-3.862,1.69-8.041,1.042-8.041,1.042 s-2.648-4.523-8.169-15.178c-3.746-7.229-4.363-11.166-5.088-14.866c-0.542-2.786-1.187-8.226-1.134-10.728l-20.723-35.213 c0,0-2.222-2.313-4.158-7.174c-2.929-7.353,0.811-17.947,0.811-17.947L219.439,150.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233.231,196.056c-1.09-7.278-2.568-16.817-5.804-28.813c-0.934-3.462-2.057-6.422-3.162-8.861 l-26.286-0.462c-1.956,4.571-3.504,10.282,0.777,17.258l1.127,8.322l15.309,26.014c-0.053,2.503,0.592,7.943,1.134,10.728 c0.725,3.7,1.342,7.637,5.088,14.866c0.165,0.317,0.318,0.612,0.477,0.918c1.661-2.478,4.255-6.496,5.247-8.843 c1.506-3.567,2.538-10.44,4.117-19.146C231.836,204.83,232.589,200.18,233.231,196.056z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4911_",
    style: {
      fill: "#37474F"
    },
    d: "M202.162,150.118c-1.3,1.332-4.537,5.796-5.065,12.666 c-0.224,2.909,0.604,8.393,4.002,12.519c1.04,15.239,4.052,44.59,4.052,44.59c-4.027,4.146-5.07,6.821-7.401,14.253 c-1.415,4.512-5.543,18.152-7.138,23.24c9.769,0.424,11.609,8.795,11.609,8.795s11.841-19.088,17.817-29.872 c4.418-7.971,4.983-9.87,6.183-14.618c1.199-4.748,1.424-9.151,2.876-19.067c1.452-9.916,4.027-23.575,4.738-33.337 c0.711-9.761,0.844-20.107,0.844-20.107L202.162,150.118z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.243,162.062c0.988-0.283,2.394-1.228,2.926-2.077c0.319-0.511,0.512-1.237,0.756-2.157 c0.267-1.004,0.599-2.255,1.23-3.662l0.753,0.337c-0.603,1.348-0.912,2.511-1.185,3.538c-0.263,0.987-0.469,1.766-0.854,2.382 c-0.631,1.011-2.266,2.155-3.555,2.463C189.286,162.61,189.261,162.336,189.243,162.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M208.815,170.794c-0.21-0.005-0.388-0.023-0.527-0.053c-1.196-0.264-2.126-1.068-3.978-3.437 c-1.411-1.804-1.266-3.1-1.028-5.246c0.088-0.788,0.918-5.001,0.97-6.111l0.791,0.44c-0.054,1.136-0.852,4.962-0.941,5.762 c-0.237,2.134-0.344,3.108,0.858,4.647c1.713,2.19,2.531,2.924,3.505,3.139c0.944,0.213,5.127-0.48,6.242-1.251 c0.643-0.448,1.722-5.954,2.352-10.8l0.818,0.107c-0.318,2.449-1.454,10.51-2.7,11.372 C214.07,170.128,210.477,170.838,208.815,170.794z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top_13_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.911,97.468c-2.792,5.337-2.446,10.117-1.641,17.604c0.743,6.905,1.264,11.182,1.9,19.723 c0.727,9.758-0.573,15.912-0.573,15.912s0.276,4.135,12.442,7.233c21.381,5.446,31.641-0.759,31.641-0.759 s0.516-12.042-0.313-27.792c-0.929-17.645-1.237-20.227-2.601-24.424c-1.003-2.319-2.9-4.404-5.47-5.571 c-2.122-0.964-7.205-2.627-10.222-3.791c-7.021-2.709-15.136-2.541-15.136-2.541C194.85,92.652,192.36,94.697,190.911,97.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M199.444,94.01c0.453,0,0.933,0.017,1.427,0.05l0.044,0.003l0.044-0.001 c0.006,0,0.098-0.002,0.266-0.002c1.348,0,8.384,0.119,14.489,2.476c1.221,0.471,2.797,1.03,4.32,1.571 c2.269,0.805,4.615,1.638,5.849,2.198c2.183,0.991,3.984,2.817,4.947,5.015c1.285,3.967,1.594,6.171,2.538,24.122 c0.716,13.601,0.421,24.546,0.333,27.123c-1.424,0.688-6.132,2.614-14.179,2.614c-5.024,0-10.487-0.743-16.237-2.207 c-10.068-2.564-11.5-5.749-11.671-6.26c0.221-1.163,1.217-7.064,0.552-15.991c-0.538-7.23-0.994-11.409-1.571-16.7 l-0.332-3.055c-0.804-7.471-1.129-11.946,1.532-17.033C192.811,95.992,194.513,94.01,199.444,94.01 M199.444,93.01 c-5.016,0-7.209,1.926-8.534,4.458c-2.792,5.337-2.446,10.117-1.641,17.604c0.743,6.905,1.264,11.182,1.9,19.723 c0.727,9.758-0.574,15.912-0.574,15.912s0.276,4.135,12.442,7.233c6.52,1.66,12.008,2.238,16.484,2.238 c10.203,0,15.157-2.997,15.157-2.997s0.516-12.042-0.313-27.792c-0.928-17.645-1.237-20.227-2.601-24.424 c-1.003-2.318-2.9-4.404-5.47-5.571c-2.123-0.964-7.205-2.627-10.222-3.791c-6.242-2.409-13.349-2.543-14.849-2.543 c-0.187,0-0.287,0.002-0.287,0.002C200.415,93.027,199.917,93.01,199.444,93.01L199.444,93.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000032644841497024455520000006801182370556244371_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M216.601,89.558l-0.575,6.491 c-3.552,0.774-12.184,0.219-13.804-1.988l0.34-5.948L216.601,89.558z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4882_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150061532897658048300000008971246726470467506_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000067224783922405146040000001487345466135191713_",
    style: {
      fill: "#F28F8F"
    },
    d: "M225.853,72.92 c0,0,1.649,1.247,2.9,5.556l-2.443,1.792C225.506,77.241,224.639,74.158,225.853,72.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4899_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4900_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M219.554,60.859c6.064,0.403,7.078,3.563,6.177,13.905 c2.128,9.819-0.811,13.703-2.077,14.989c-2.858,1.531-5.763,1.784-9.711,0.755c-3.009-0.784-10.632-3.045-13.825-7.775 c-3.756-5.565-4.738-14.027-0.737-17.176C205.011,61.124,217.139,60.699,219.554,60.859z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M223.654,89.753c-0.701,0.711-4.758,1.996-7.258,1.722l0.206-1.917 C216.601,89.558,220.074,90.207,223.654,89.753z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1617_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005976154114993435590000015591932290200612267_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000082342501386592433430000004414790631549292214_",
    style: {
      fill: "#263238"
    },
    d: "M220.188,68.002 c-0.129,0.444-0.322,0.87-0.57,1.26c-0.682,1.073-1.656,1.65-2.695,2.301c0.378,1.265,0.786,2.574,0.803,3.916 c0.005,0.429-0.029,0.883-0.272,1.242c-0.427,0.634-1.147,0.572-1.479-0.016c-0.398-0.706-0.677-1.441-1.234-2.054 c-0.644-0.709-1.524-1.246-2.491-1.341c-3.658-0.356-3.672,5.339-2.205,7.267c2.4,3.156,4.371,1.131,4.371,1.131 s1.234,4.867-2.293,6.976c0,0-5.683,1.393-9.561-0.571c-1.775-3.653-4.169-5.785-6.075-9.675 c-3.334-6.805-1.737-12.782,0.535-14.011c-0.639-3.178,1.294-6.301,5.405-8.24c4.052-1.912,9.652-0.937,13.961-0.247 c2.56,0.41,5.208,0.26,7.706-0.436c0.354-0.099,0.712-0.209,1.079-0.208c0.367,0.002,0.756,0.135,0.968,0.435 c0.277,0.391,0.18,0.938-0.032,1.367c-0.212,0.429-0.526,0.809-0.683,1.262c0.888-0.242,1.816,0.419,2.216,1.248 c0.561,1.161,0.328,2.608-0.407,3.667c-0.735,1.059-1.908,1.757-3.144,2.124c-1.236,0.366-2.541,0.427-3.83,0.418 C220.434,66.535,220.394,67.291,220.188,68.002z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M216.272,93.279c0.927-0.045,1.934,1.869,3.753,3.763c0,0-5.127,2.974-12.775,1.822 c-7.647-1.152-9.115-5.806-9.115-5.806s1.748-1.342,2.669-2.247c1.12-1.1,1.668-1.118,1.668-1.118l-0.09,1.566 c0,0,1.467,1.519,6.128,2.462C213.172,94.663,216.272,93.279,216.272,93.279z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Arm_00000011716718743027405930000017792785235835785398_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M243.339,138.313 c-0.001-0.001-2.186-10.963-3.78-18.65c-1.594-7.686-0.977-16.565-13.076-19.607c-2.001,3.053-3.306,7.73-2.631,13.563 c0.675,5.833,3.336,14.981,4.005,18.073c0.67,3.092,2.936,9.25,5.82,13.535c3.835,5.698,10.987,15.338,13.883,18.881 c1.34,1.64,2.502,3.3,3.735,5.044c1.286,1.818,2.993,3.231,4.517,4.857c0.703,0.751,1.713,1.289,2.701,1.565 c0.65,0.182,1.295-0.068,1.911,0.102c0.638,0.175,1.024,0.764,1.778,0.785c0.838,0.023,1.519-0.555,2.276-0.482 c0.792,0.076,1.564,0.363,2.394,0.342c0.748-0.02,1.258-0.126,1.974,0.173c0.586,0.246,1.406,1.022,2.074,0.626 c0.748-0.445,0.52-1.262,0.255-1.937c-0.468-1.191-1.779-2.36-2.896-2.952c-1.294-0.686-2.412-1.663-3.784-2.197 c-1.241-0.482-2.327-1.544-3.222-2.538c-0.625-0.695-1.034-1.768,0.234-1.783c1.494-0.017,3.347,0.55,4.707-0.394 c0.941-0.653,0.622-1.485-0.29-1.88c-1.526-0.662-2.913-1.399-4.337-2.282c-1.417-0.879-2.726-1.902-4.163-2.738 c-0.747-0.435-1.568-0.798-2.373-1.132c-2.253-0.936-3.234-3.19-4.37-5.18C249.098,149.332,245.113,142.002,243.339,138.313z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M225.896,126.594c0,0-2.121-8.338-2.665-11.822c-0.545-3.484-0.854-12.546,2.755-15.514 c2.605,0.634,9.573,1.874,11.58,8.428c2.008,6.554,5.037,23.816,5.037,23.816l9.072,21.427c0,0,0.036,1.996-3.765,4.571 c-3.801,2.576-5.74,1.698-5.74,1.698s-7.491-11.339-11.126-16.928C228.604,138.516,228.003,136.028,225.896,126.594z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_00000168074982404905952840000003505087169070105221_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M157.351,90.768l0.016-12.888l10.839-1.142c0.236-0.025,0.448,0.027,0.623,0.13 c0.525,0.308,5.509,3.193,5.682,3.293c0.53,0.305,0.725,1.075,0.232,1.594l-11.703,12.311L157.351,90.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5443_",
    style: {
      fill: "#00AB55"
    },
    d: "M123.349,119.845l-0.001-39.88c0-0.579,0.407-1.284,0.908-1.573l32.521-18.738 c0.502-0.29,1.313-0.286,1.811,0.009l5.057,2.987c0.499,0.295,0.903,1.003,0.903,1.582l0.001,39.88 c0,0.579-0.407,1.284-0.908,1.573l-32.521,18.738c-0.502,0.29-1.313,0.286-1.811-0.009l-5.057-2.987 C123.754,121.133,123.349,120.424,123.349,119.845z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5442_",
    style: {
      opacity: 0.15
    },
    d: "M130.972,124.495c-0.432,0.167-0.76-0.075-0.762-0.597l0.002-39.878 c0.001-0.291,0.102-0.611,0.268-0.896l-6.885-4.022c-0.154,0.278-0.249,0.584-0.247,0.865l0,39.881 c-0.001,0.577,0.402,1.284,0.903,1.581l5.056,2.986C129.762,124.68,130.472,124.711,130.972,124.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M173.897,80.035l-9.347,0.985l-0.001-16.788c0-0.579-0.407-0.814-0.908-0.524L131.12,82.445 c-0.501,0.29-0.908,0.994-0.908,1.573l0.001,39.88c0,0.579,0.406,0.814,0.908,0.524l32.521-18.738 c0.502-0.29,0.909-0.994,0.909-1.573l-0.001-11.634l10.194-10.724C175.398,81.066,174.841,79.935,173.897,80.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#FFFFFF"
    },
    d: "M173.897,80.035l-9.347,0.985l-0.001-16.788c0-0.579-0.407-0.814-0.908-0.524 L131.12,82.445c-0.501,0.29-0.908,0.994-0.908,1.573l0.001,39.88c0,0.579,0.406,0.814,0.908,0.524l32.521-18.738 c0.502-0.29,0.909-0.994,0.909-1.573l-0.001-11.634l10.194-10.724C175.398,81.066,174.841,79.935,173.897,80.035z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Gear_00000162334576627926917480000014737056611456918456_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M156.848,98.058 c0.071-0.185,0.071-0.374-0.008-0.463l-1.392-1.543c-0.314-0.352-0.376-1.025-0.171-1.804c0.009-0.015,0.01-0.027,0.011-0.038 c0,0,0,0,0.005-0.007c0.199-0.76,0.631-1.462,1.129-1.826l2.227-1.619c0.131-0.093,0.234-0.281,0.258-0.468 c0.119-0.938,0.178-1.906,0.181-2.861c0.003-0.917-0.055-1.813-0.172-2.675c-0.023-0.152-0.123-0.226-0.254-0.171l-2.225,0.941 c-0.496,0.202-0.927,0.01-1.124-0.513c-0.006-0.02-0.009-0.035-0.015-0.055c-0.204-0.531-0.139-1.29,0.178-1.994l1.395-3.141 c0.078-0.177,0.083-0.373,0.008-0.47c-0.796-1.066-1.776-1.821-2.924-2.224c-0.103-0.04-0.241,0.045-0.346,0.206l-1.756,2.864 c-0.39,0.635-0.939,1.042-1.432,1.059c-0.008,0.003-0.015-0.005-0.024-0.001c-0.491,0.006-0.826-0.382-0.88-1.008l-0.25-2.825 c-0.014-0.166-0.114-0.241-0.24-0.205c-1.32,0.441-2.822,1.307-4.148,2.383c-0.123,0.102-0.223,0.293-0.238,0.477l-0.262,3.122 c-0.051,0.687-0.394,1.463-0.88,2.016c-0.009,0.015-0.017,0.018-0.027,0.033c-0.494,0.545-1.043,0.774-1.43,0.581l-1.748-0.845 c-0.103-0.052-0.244,0.03-0.352,0.186c-1.144,1.721-2.131,3.604-2.934,5.593c-0.075,0.181-0.071,0.374,0.008,0.463l1.388,1.539 c0.312,0.336,0.371,1.032,0.167,1.8c-0.002,0.023-0.007,0.042-0.013,0.061c-0.209,0.775-0.626,1.443-1.124,1.807l-2.24,1.63 c-0.122,0.09-0.23,0.285-0.249,0.465c-0.12,0.949-0.183,1.913-0.185,2.868c-0.001,0.944,0.057,1.841,0.174,2.652 c0.022,0.163,0.127,0.23,0.255,0.171l2.232-0.933c0.492-0.206,0.922-0.003,1.13,0.532c-0.001,0.012,0.006,0.02,0.005,0.031 c0.207,0.546,0.143,1.294-0.174,1.998l-1.392,3.145c-0.083,0.185-0.087,0.369-0.017,0.473c0.799,1.07,1.784,1.818,2.928,2.228 c0.104,0.04,0.246-0.053,0.347-0.217l1.756-2.865c0.39-0.635,0.94-1.042,1.431-1.048c0.008-0.003,0.02-0.003,0.028-0.006 c0.487-0.009,0.819,0.374,0.876,1.005l0.25,2.825c0.014,0.166,0.109,0.248,0.24,0.205c0.66-0.22,1.356-0.539,2.071-0.949 c0.712-0.414,1.41-0.894,2.077-1.434c0.123-0.102,0.219-0.297,0.238-0.477l0.262-3.122c0.055-0.695,0.389-1.456,0.876-2.008 c0.013-0.011,0.026-0.022,0.03-0.029c0.494-0.556,1.036-0.783,1.431-0.593l1.747,0.857c0.099,0.048,0.244-0.03,0.349-0.19 C155.059,101.919,156.042,100.043,156.848,98.058z M146.919,102.607c-3.393,1.945-6.143-0.149-6.133-4.669 c0.007-4.524,2.768-9.794,6.158-11.743c3.386-1.942,6.134,0.163,6.128,4.687C153.065,95.406,150.301,100.662,146.919,102.607z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanUpgrade);
export default __webpack_public_path__ + "static/media/plan-upgrade.900025388d6a59d636a955c4bd8c0b25.svg";
export { ForwardRef as ReactComponent };